var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "translate(-218.85 -158.95)",
    id: "svg_99"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#F3F3F3",
    d: "m678.03631,761.75495l-6.6824,-80.87895c-0.07843,-2.27452 1.05099,-4.43924 2.98041,-5.66278l49.69444,-36.23553c2.80786,-1.88236 6.19612,-2.68237 9.553,-2.25884l133.99301,14.32166c4.21963,0.4549 7.67064,2.57257 8.81574,5.4118l18.82365,46.18069c0.36079,0.84706 0.48628,1.77256 0.37647,2.68237l-6.61965,56.21997l-210.93468,0.21961z",
    className: "st0",
    id: "svg_402"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m884.31214,603.69904l-73.14557,0c-1.64707,0 -2.9961,-1.34903 -2.9961,-2.9961l0,-124.95766c0,-1.64707 1.34903,-2.9961 2.9961,-2.9961l73.14557,0c1.64707,0 2.9961,1.34903 2.9961,2.9961l0,124.95766c-0.01569,1.66276 -1.34903,2.9961 -2.9961,2.9961z",
    className: "st1",
    id: "svg_401"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    fill: "#FFFFFF",
    opacity: 0.2,
    d: "m884.31214,603.69904l-73.14557,0c-1.64707,0 -2.9961,-1.34903 -2.9961,-2.9961l0,-124.95766c0,-1.64707 1.34903,-2.9961 2.9961,-2.9961l73.14557,0c1.64707,0 2.9961,1.34903 2.9961,2.9961l0,124.95766c-0.01569,1.66276 -1.34903,2.9961 -2.9961,2.9961z",
    className: "st2",
    id: "svg_400"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m886.06902,603.69904l-73.11419,0c-1.64707,0 -2.9961,-1.34903 -2.9961,-2.9961l0,-124.95766c0,-1.64707 1.34903,-2.9961 2.9961,-2.9961l73.14557,0c1.64707,0 2.9961,1.34903 2.9961,2.9961l0,124.95766c-0.03137,1.66276 -1.3804,2.98041 -3.02747,2.9961z",
    className: "st1",
    id: "svg_399"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    fill: "#FFFFFF",
    opacity: 0.6,
    d: "m886.06902,603.69904l-73.11419,0c-1.64707,0 -2.9961,-1.34903 -2.9961,-2.9961l0,-124.95766c0,-1.64707 1.34903,-2.9961 2.9961,-2.9961l73.14557,0c1.64707,0 2.9961,1.34903 2.9961,2.9961l0,124.95766c-0.03137,1.66276 -1.3804,2.98041 -3.02747,2.9961z",
    className: "st3",
    id: "svg_398"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m877.1121,589.89503l-20.43935,0c-0.53334,0 -0.97256,-0.42353 -0.97256,-0.95687c0,0 0,-0.01569 0,-0.01569l0,-5.05101c0,-0.53334 0.42353,-0.97256 0.95687,-0.97256c0,0 0.01569,0 0.01569,0l20.43935,0c0.53334,0 0.97256,0.42353 0.97256,0.95687c0,0 0,0.01569 0,0.01569l0,5.05101c0.01569,0.53334 -0.42353,0.95687 -0.97256,0.97256c0.01569,0 0.01569,0 0,0z",
    className: "st4",
    id: "svg_397"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#F3F3F3",
    d: "m871.65324,587.11854l-9.47457,0c-0.39216,0 -0.70589,-0.31373 -0.70589,-0.70589l0,0c0.01569,-0.39216 0.32941,-0.6902 0.70589,-0.70589l9.47457,0c0.39216,0 0.70589,0.31373 0.70589,0.70589s-0.31373,0.70589 -0.70589,0.70589l0,0z",
    className: "st0",
    id: "svg_396"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m819.84114,584.2793l0.51765,1.05099c0.03137,0.06275 0.1098,0.1098 0.18824,0.1098l1.12942,0.15686c0.1098,0.01569 0.20392,0.1098 0.18824,0.2353c0,0.06275 -0.03137,0.1098 -0.07843,0.14118l-0.83138,0.78432c-0.04706,0.04706 -0.07843,0.1098 -0.07843,0.18824l0.18824,1.12942c0.03137,0.1098 -0.04706,0.2353 -0.15686,0.26667c-0.06275,0.01569 -0.12549,0 -0.17255,-0.03137l-1.00393,-0.51765c-0.06275,-0.03137 -0.15686,-0.03137 -0.21961,0l-1.00393,0.51765c-0.18824,0.07843 -0.37647,-0.07843 -0.3451,-0.21961l0.18824,-1.12942c0,-0.07843 0,-0.15686 -0.07843,-0.18824l-0.83138,-0.78432c-0.15686,-0.15686 -0.07843,-0.37647 0.1098,-0.37647l1.12942,-0.15686c0.07843,0 0.15686,-0.04706 0.18824,-0.1098l0.51765,-1.05099c0.09412,-0.12549 0.26667,-0.15686 0.39216,-0.06275c0.03137,0 0.04706,0.01569 0.06275,0.04706z",
    className: "st1",
    id: "svg_395"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m825.56667,584.2793l0.51765,1.05099c0.03137,0.06275 0.1098,0.1098 0.18824,0.1098l1.12942,0.15686c0.1098,0.01569 0.20392,0.1098 0.18824,0.2353c0,0.06275 -0.03137,0.1098 -0.07843,0.14118l-0.83138,0.78432c-0.04706,0.04706 -0.07843,0.1098 -0.07843,0.18824l0.18824,1.12942c0.03137,0.1098 -0.04706,0.2353 -0.15686,0.26667c-0.06275,0.01569 -0.12549,0 -0.17255,-0.03137l-1.00393,-0.51765c-0.06275,-0.03137 -0.15686,-0.03137 -0.21961,0l-1.00393,0.51765c-0.15686,0.07843 -0.37647,-0.07843 -0.3451,-0.21961l0.18824,-1.12942c0,-0.07843 0,-0.15686 -0.07843,-0.18824l-0.83138,-0.78432c-0.15686,-0.15686 -0.07843,-0.37647 0.1098,-0.37647l1.12942,-0.15686c0.07843,0 0.15686,-0.04706 0.18824,-0.1098l0.51765,-1.05099c0.09412,-0.12549 0.26667,-0.15686 0.39216,-0.06275c0.03137,0 0.04706,0.01569 0.06275,0.04706z",
    className: "st1",
    id: "svg_394"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m831.26082,584.2793l0.51765,1.05099c0.03137,0.06275 0.1098,0.1098 0.18824,0.1098l1.12942,0.15686c0.1098,0.01569 0.20392,0.1098 0.18824,0.2353c0,0.06275 -0.03137,0.1098 -0.07843,0.14118l-0.83138,0.78432c-0.04706,0.04706 -0.07843,0.1098 -0.07843,0.18824l0.18824,1.12942c0.03137,0.1098 -0.04706,0.2353 -0.15686,0.26667c-0.06275,0.01569 -0.12549,0 -0.17255,-0.03137l-1.00393,-0.51765c-0.06275,-0.03137 -0.15686,-0.03137 -0.21961,0l-1.00393,0.51765c-0.18824,0.07843 -0.37647,-0.07843 -0.3451,-0.21961l0.18824,-1.12942c0,-0.07843 0,-0.15686 -0.07843,-0.18824l-0.83138,-0.78432c-0.15686,-0.15686 -0.07843,-0.37647 0.1098,-0.37647l1.12942,-0.15686c0.07843,0 0.15686,-0.04706 0.18824,-0.1098l0.51765,-1.05099c0.15686,-0.17255 0.37647,-0.17255 0.4549,-0.01569z",
    className: "st1",
    id: "svg_393"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m836.98635,584.2793l0.51765,1.05099c0.03137,0.06275 0.1098,0.1098 0.18824,0.1098l1.12942,0.15686c0.1098,0.01569 0.20392,0.1098 0.18824,0.2353c0,0.06275 -0.03137,0.1098 -0.07843,0.14118l-0.83138,0.78432c-0.04706,0.04706 -0.07843,0.1098 -0.07843,0.18824l0.18824,1.12942c0.03137,0.1098 -0.04706,0.2353 -0.15686,0.26667c-0.06275,0.01569 -0.12549,0 -0.17255,-0.03137l-1.00393,-0.51765c-0.06275,-0.03137 -0.15686,-0.03137 -0.21961,0l-1.00393,0.51765c-0.15686,0.07843 -0.37647,-0.07843 -0.3451,-0.21961l0.18824,-1.12942c0,-0.07843 0,-0.15686 -0.07843,-0.18824l-0.83138,-0.78432c-0.15686,-0.15686 -0.07843,-0.37647 0.1098,-0.37647l1.12942,-0.15686c0.07843,0 0.15686,-0.04706 0.18824,-0.1098l0.51765,-1.05099c0.09412,-0.12549 0.26667,-0.15686 0.39216,-0.06275c0.03137,0 0.04706,0.01569 0.06275,0.04706z",
    className: "st1",
    id: "svg_392"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m842.71188,584.2793l0.51765,1.05099c0.03137,0.06275 0.1098,0.1098 0.18824,0.1098l1.12942,0.15686c0.1098,0.01569 0.20392,0.1098 0.18824,0.2353c0,0.06275 -0.03137,0.1098 -0.07843,0.14118l-0.83138,0.78432c-0.04706,0.04706 -0.07843,0.1098 -0.07843,0.18824l0.18824,1.12942c0.03137,0.1098 -0.04706,0.2353 -0.15686,0.26667c-0.06275,0.01569 -0.12549,0 -0.17255,-0.03137l-1.00393,-0.51765c-0.06275,-0.03137 -0.15686,-0.03137 -0.21961,0l-1.00393,0.51765c-0.18824,0.07843 -0.37647,-0.07843 -0.3451,-0.21961l0.18824,-1.12942c0,-0.07843 0,-0.15686 -0.07843,-0.18824l-0.83138,-0.78432c-0.15686,-0.15686 -0.07843,-0.37647 0.1098,-0.37647l1.12942,-0.15686c0.07843,0 0.15686,-0.04706 0.18824,-0.1098l0.51765,-1.05099c0.09412,-0.12549 0.26667,-0.15686 0.39216,-0.06275c0.03137,0 0.04706,0.01569 0.06275,0.04706z",
    className: "st1",
    id: "svg_391"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m849.53545,525.64364c12.59616,0 22.7923,-10.21183 22.7923,-22.7923c0,-12.59616 -10.21183,-22.7923 -22.7923,-22.7923c-12.59616,0 -22.7923,10.21183 -22.7923,22.7923c0,12.58047 10.19614,22.7923 22.7923,22.7923z",
    className: "st5",
    id: "svg_390"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m858.58649,493.94147l0,5.64709l-3.13727,0.21961l0.4549,-3.96865l2.68237,-1.89805z",
    className: "st4",
    id: "svg_389"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m857.4257,511.91806l11.34125,1.49021c3.15296,0.40785 5.45886,3.15296 5.31768,6.32161l-0.70589,19.24718l-43.38851,0l-0.70589,-19.43542c-0.1098,-3.09022 2.08629,-5.77259 5.12944,-6.29024l10.03928,-1.67844l12.97263,0.3451z",
    className: "st4",
    id: "svg_388"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m857.4257,511.91806c0,0.03137 1.2706,0.1098 1.2706,0.18824l0,0.21961c0,2.40002 -3.48238,4.3765 -7.8275,4.3765c-4.29807,0 -7.8275,-1.94511 -7.8275,-4.3765c0,-0.18824 0.03137,-0.37647 0.07843,-0.56471c0,-0.07843 1.23922,-0.15686 1.2706,-0.21961l13.03538,0.37647z",
    className: "st1",
    id: "svg_387"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#966363",
    d: "m844.51581,497.64346c0,0 11.49811,-7.23142 11.93733,1.6157l-0.3451,2.13335l0.94118,10.9334c0.3451,4.18826 -12.61185,4.3765 -12.61185,-0.26667l0.75295,-5.80396c-0.15686,-0.65883 -0.2353,-1.34903 -0.21961,-2.02354c-0.15686,-3.43532 -0.4549,-6.58828 -0.4549,-6.58828z",
    className: "st6",
    id: "svg_386"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m843.46482,497.31404c2.14903,0 3.89022,-1.74119 3.89022,-3.89022s-1.74119,-3.89022 -3.89022,-3.89022s-3.89022,1.74119 -3.89022,3.89022l0,0c0.01569,2.13335 1.75687,3.85885 3.89022,3.89022z",
    className: "st4",
    id: "svg_385"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#966363",
    d: "m843.19815,491.43165c0,0 -4.07846,17.11384 4.7216,18.27463c7.59221,1.00393 8.45496,-10.85497 8.45496,-10.85497l-0.37647,-7.67064l-12.80008,0.25098z",
    className: "st6",
    id: "svg_384"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m854.91588,497.016c0.14118,2.14903 -0.01569,4.29807 -0.48628,6.40004c-0.21961,0.75295 -0.75295,1.45883 -2.24315,0.59608c-5.69415,-3.18433 -9.61575,-0.21961 -9.61575,-0.21961s0.56471,4.67454 4.45493,5.69415c3.70198,1.06667 7.56083,-1.05099 8.62751,-4.75297c0.18824,-0.62745 0.28235,-1.28628 0.28235,-1.94511c0.20392,-2.11766 0.14118,-4.26669 -0.18824,-6.36867c-0.51765,-1.94511 -1.19216,-2.05492 -1.19216,-2.05492l0.36079,2.651z",
    className: "st4",
    id: "svg_383"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m847.27661,484.21592c1.94511,-0.06275 3.7961,0.76863 5.05101,2.24315c0.53334,0.67451 1.39609,0.98824 2.24315,0.81569c0.25098,-0.01569 0.50196,-0.01569 0.75295,0c6.85495,0.48628 5.88239,10.74517 -0.3451,9.91379c-1.42746,-0.25098 -2.61962,-1.23922 -3.13727,-2.58825c-0.43922,-1.00393 -1.56864,-1.53726 -2.61962,-1.23922c-0.62745,0.18824 -1.28628,0.26667 -1.94511,0.26667c-3.29414,0 -5.94514,-2.10197 -5.94514,-4.7216c0.03137,-2.60394 2.69806,-4.69023 5.94514,-4.69023z",
    className: "st4",
    id: "svg_382"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#966363",
    d: "m843.13541,492.82774c0.3451,0.2353 0.70589,0.42353 1.08236,0.59608c0.07843,0.03137 0.17255,0 0.21961,-0.07843c0.04706,-0.09412 0.01569,-0.20392 -0.07843,-0.26667c0,0 -1.00393,-0.59608 -1.12942,-0.67451c-0.29804,-0.21961 -0.54902,-0.47059 -0.78432,-0.75295c-0.06275,-0.07843 -0.17255,-0.09412 -0.26667,-0.03137s-0.09412,0.17255 -0.03137,0.26667c0.29804,0.3451 0.62745,0.65883 0.98824,0.94118z",
    className: "st6",
    id: "svg_381"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m844.65699,510.9455l0.26667,-2.61962c1.34903,1.17648 3.15296,1.66276 4.90984,1.34903c1.19216,-0.12549 2.35296,-0.48628 3.40394,-1.05099c0.07843,-0.06275 0.20392,-0.07843 0.29804,-0.03137c0.07843,0.07843 0.03137,0.15686 -0.03137,0.21961c-1.12942,0.6902 -2.40002,1.11373 -3.70198,1.23922c-1.49021,1.08236 -3.38826,1.41177 -5.14513,0.89412z",
    className: "st7",
    id: "svg_380"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m849.48839,498.96111c0.39216,0 0.70589,-0.31373 0.70589,-0.70589s-0.31373,-0.70589 -0.70589,-0.70589s-0.70589,0.31373 -0.70589,0.70589c0.03137,0.37647 0.32941,0.67451 0.70589,0.70589z",
    className: "st4",
    id: "svg_379"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m849.20604,498.17679c0.09412,0 0.15686,-0.06275 0.15686,-0.15686s-0.06275,-0.15686 -0.15686,-0.15686c-0.09412,0 -0.15686,0.06275 -0.15686,0.15686c0,0 0,0 0,0c0,0.07843 0.06275,0.15686 0.15686,0.15686z",
    className: "st5",
    id: "svg_378"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m843.91973,498.99248c0.39216,0 0.70589,-0.31373 0.70589,-0.70589c0,-0.39216 -0.31373,-0.70589 -0.70589,-0.70589c-0.37647,-0.01569 -0.70589,0.28235 -0.70589,0.65883c0,0.01569 0,0.03137 0,0.04706c0.01569,0.37647 0.31373,0.6902 0.70589,0.70589z",
    className: "st4",
    id: "svg_377"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m843.62169,498.20817c0.09412,0 0.15686,-0.06275 0.15686,-0.15686s-0.06275,-0.15686 -0.15686,-0.15686c-0.09412,0 -0.15686,0.06275 -0.15686,0.15686c0,0 0,0 0,0c0,0.09412 0.06275,0.15686 0.15686,0.15686z",
    className: "st5",
    id: "svg_376"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m840.92363,497.45522l0,0.78432c0,1.53726 1.23922,2.77649 2.7608,2.77649c1.53726,0 2.77649,-1.23922 2.77649,-2.7608c0,0 0,-0.01569 0,-0.01569l0,-0.78432c0.01569,-0.2353 -0.04706,-0.4549 -0.18824,-0.64314l1.08236,0c-0.14118,0.18824 -0.21961,0.40785 -0.21961,0.64314l0,0.78432c0,1.53726 1.23922,2.77649 2.7608,2.77649c1.53726,0 2.77649,-1.23922 2.77649,-2.7608c0,0 0,-0.01569 0,-0.01569l0,-0.78432c0,-0.54902 -0.4549,-1.00393 -1.00393,-1.00393c0,0 0,0 0,0l-9.61575,0c-0.56471,-0.04706 -1.06667,0.37647 -1.11373,0.94118c-0.01569,0.03137 -0.01569,0.04706 -0.01569,0.06275zm7.15299,-0.59608l3.48238,0c0.3451,0.01569 0.62745,0.28235 0.64314,0.64314l0,0.78432c0.01569,1.28628 -1.00393,2.35296 -2.3059,2.38433s-2.35296,-1.00393 -2.38433,-2.3059c0,-0.03137 0,-0.07843 0,-0.1098l0,-0.78432c-0.01569,-0.31373 0.21961,-0.5804 0.51765,-0.59608c0.01569,-0.01569 0.03137,-0.01569 0.04706,-0.01569l0,0zm-6.77651,0.64314c0.01569,-0.3451 0.28235,-0.62745 0.64314,-0.64314l3.48238,0c0.3451,0.01569 0.62745,0.28235 0.64314,0.64314l0,0.78432c-0.04706,1.28628 -1.12942,2.3059 -2.4157,2.25884c-1.23922,-0.04706 -2.24315,-1.05099 -2.25884,-2.3059l-0.09412,-0.73726z",
    className: "st4",
    id: "svg_375"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#966363",
    d: "m855.98255,502.36505l-0.15686,-4.3765c0.32941,-0.95687 1.3804,-1.47452 2.33727,-1.12942c0.04706,0.01569 0.09412,0.03137 0.12549,0.04706c2.10197,0.86275 0.56471,6.40004 -2.3059,5.45886z",
    className: "st6",
    id: "svg_374"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.5,
    className: "st8",
    transform: "translate(336.741 193.457)",
    id: "svg_372"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.5,
    d: "m328.30858,196.35525c0.1098,0 0.21961,-0.1098 0.21961,-0.21961c0,-0.70589 0.15686,-1.16079 0.4549,-1.34903c0.26667,-0.12549 0.5804,-0.14118 0.86275,-0.03137c0.1098,0.04706 0.25098,0 0.29804,-0.1098c0.04706,-0.1098 0,-0.25098 -0.1098,-0.29804l0,0c-0.43922,-0.17255 -0.90981,-0.15686 -1.31766,0.06275c-0.50196,0.42353 -0.76863,1.06667 -0.67451,1.7255c0.03137,0.12549 0.14118,0.20392 0.26667,0.21961z",
    className: "st9",
    id: "svg_373"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m849.15898,504.0435l-3.67061,0l0.1098,0.29804c0.40785,0.95687 1.52158,1.39609 2.47845,0.98824c0.53334,-0.2353 0.94118,-0.70589 1.08236,-1.28628z",
    className: "st5",
    id: "svg_371"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.5,
    className: "st8",
    transform: "translate(329.676 195.152)",
    id: "svg_369"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.5,
    d: "m329.0929,196.35525l0.40785,0c0.12549,0 0.2353,-0.09412 0.2353,-0.21961s-0.1098,-0.2353 -0.2353,-0.2353l-0.40785,0c-0.3451,-0.01569 -0.62745,-0.28235 -0.64314,-0.64314c-0.01569,-0.28235 0.20392,-0.54902 0.48628,-0.5804c0.12549,-0.03137 0.21961,-0.14118 0.18824,-0.26667s-0.12549,-0.20392 -0.25098,-0.18824l0,0c-0.48628,0.12549 -0.83138,0.54902 -0.83138,1.05099c-0.03137,0.56471 0.40785,1.05099 0.97256,1.08236c0.03137,0 0.04706,0 0.07843,0z",
    className: "st9",
    id: "svg_370"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m877.23759,534.74173l-56.00036,0c-0.6902,0.01569 -1.25491,-0.54902 -1.2706,-1.23922c0,-0.01569 0,-0.01569 0,-0.03137l0,-0.94118c-0.01569,-0.6902 0.54902,-1.25491 1.23922,-1.2706c0.01569,0 0.01569,0 0.03137,0l56.00036,0c0.6902,-0.01569 1.25491,0.54902 1.2706,1.23922c0,0.01569 0,0.01569 0,0.03137l0,0.94118c-0.03137,0.6902 -0.5804,1.25491 -1.2706,1.2706z",
    className: "st1",
    id: "svg_368"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#F3F3F3",
    d: "m869.51989,541.78492l-40.61202,0c-0.4549,0 -0.81569,-0.37647 -0.81569,-0.83138c0,-0.4549 0.36079,-0.81569 0.81569,-0.81569l40.61202,0c0.4549,0 0.81569,0.37647 0.83138,0.81569c0.01569,0.43922 -0.3451,0.81569 -0.78432,0.81569c-0.03137,0.01569 -0.03137,0.01569 -0.04706,0.01569z",
    className: "st0",
    id: "svg_367"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.6,
    className: "st10",
    transform: "translate(320.99 228.347)",
    id: "svg_363"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    fill: "#FFFFFF",
    opacity: 0.6,
    d: "m377.01478,195.60231l-48.29835,0c-0.37647,0 -0.67451,-0.29804 -0.67451,-0.67451c0,0 0,0 0,0l0,-0.03137c0,-0.37647 0.29804,-0.67451 0.67451,-0.67451c0,0 0,0 0,0l48.28266,0c0.37647,0 0.67451,0.29804 0.67451,0.67451c0,0 0,0 0,0l0,0.03137c0.01569,0.37647 -0.28235,0.67451 -0.65883,0.67451c0,0 0,0 0,0z",
    className: "st3",
    id: "svg_366"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    fill: "#FFFFFF",
    opacity: 0.6,
    d: "m377.01478,207.74356l-48.29835,0c-0.37647,-0.03137 -0.65883,-0.3451 -0.64314,-0.72157c0.01569,-0.3451 0.29804,-0.62745 0.64314,-0.64314l48.28266,0c0.37647,0 0.67451,0.29804 0.67451,0.67451c0,0 0,0 0,0l0,0.03137c0,0.37647 -0.29804,0.65883 -0.65883,0.65883z",
    className: "st3",
    id: "svg_365"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    fill: "#FFFFFF",
    opacity: 0.6,
    d: "m377.01478,219.9005l-48.29835,0c-0.37647,0 -0.67451,-0.29804 -0.67451,-0.67451c0,0 0,0 0,0l0,-0.03137c0,-0.37647 0.29804,-0.67451 0.67451,-0.67451c0,0 0,0 0,0l48.28266,0c0.37647,0 0.67451,0.29804 0.67451,0.67451c0,0 0,0 0,0l0,0.03137c0.01569,0.37647 -0.28235,0.67451 -0.65883,0.67451c0,0 0,0 0,0z",
    className: "st3",
    id: "svg_364"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    fill: "#FFFFFF",
    opacity: 0.8,
    d: "m823.02548,552.0438l-4.75297,0c-0.47059,0.01569 -0.84706,-0.36079 -0.86275,-0.83138c0,-0.01569 0,-0.01569 0,-0.03137l0,-4.75297c-0.01569,-0.47059 0.36079,-0.84706 0.83138,-0.86275c0.01569,0 0.01569,0 0.03137,0l4.75297,0c0.47059,-0.01569 0.84706,0.36079 0.86275,0.83138c0,0.01569 0,0.01569 0,0.03137l0,4.75297c0,0.47059 -0.39216,0.86275 -0.86275,0.86275z",
    className: "st11",
    id: "svg_362"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m820.18624,550.23987l-1.45883,-1.45883l0.48628,-0.48628l0.97256,0.97256l1.91374,-1.91374l0.48628,0.48628l-2.40002,2.40002z",
    className: "st1",
    id: "svg_361"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    fill: "#FFFFFF",
    opacity: 0.8,
    d: "m823.02548,563.65172l-4.75297,0c-0.47059,0.01569 -0.84706,-0.36079 -0.86275,-0.83138c0,-0.01569 0,-0.01569 0,-0.03137l0,-4.75297c-0.01569,-0.47059 0.36079,-0.84706 0.83138,-0.86275c0.01569,0 0.01569,0 0.03137,0l4.75297,0c0.47059,-0.01569 0.84706,0.36079 0.86275,0.83138c0,0.01569 0,0.01569 0,0.03137l0,4.75297c0.01569,0.47059 -0.36079,0.84706 -0.83138,0.86275c-0.01569,0 -0.01569,0 -0.03137,0z",
    className: "st11",
    id: "svg_360"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m820.18624,561.87916l-1.45883,-1.45883l0.48628,-0.48628l0.97256,0.97256l1.91374,-1.94511l0.48628,0.48628l-2.40002,2.43139z",
    className: "st1",
    id: "svg_359"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    fill: "#FFFFFF",
    opacity: 0.8,
    d: "m823.02548,575.29101l-4.75297,0c-0.47059,0.01569 -0.84706,-0.36079 -0.86275,-0.83138c0,-0.01569 0,-0.01569 0,-0.03137l0,-4.75297c-0.01569,-0.47059 0.36079,-0.84706 0.83138,-0.86275c0.01569,0 0.01569,0 0.03137,0l4.75297,0c0.47059,-0.01569 0.84706,0.36079 0.86275,0.83138c0,0.01569 0,0.01569 0,0.03137l0,4.75297c0,0.47059 -0.39216,0.84706 -0.86275,0.86275z",
    className: "st11",
    id: "svg_358"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m820.18624,573.48708l-1.45883,-1.45883l0.48628,-0.48628l0.97256,0.97256l1.91374,-1.94511l0.48628,0.48628l-2.40002,2.43139z",
    className: "st1",
    id: "svg_357"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m944.13998,497.87875c0.09412,0 0.15686,-0.06275 0.15686,-0.15686s-0.06275,-0.15686 -0.15686,-0.15686c-0.09412,0 -0.15686,0.06275 -0.15686,0.15686c0,0 0,0 0,0c0,0.07843 0.06275,0.15686 0.15686,0.15686z",
    className: "st5",
    id: "svg_356"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m939.19877,497.80032c0.09412,0 0.15686,-0.06275 0.15686,-0.15686s-0.06275,-0.15686 -0.15686,-0.15686c-0.09412,0 -0.15686,0.06275 -0.15686,0.15686c0,0 0,0 0,0c-0.01569,0.07843 0.03137,0.14118 0.1098,0.15686c0.01569,0 0.03137,0 0.04706,0z",
    className: "st5",
    id: "svg_355"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m856.53157,464.29422l-15.79618,0c-1.34903,0 -2.43139,-1.09805 -2.43139,-2.43139c0,-0.01569 0,-0.01569 0,-0.03137l0,-15.79618c0,-1.34903 1.08236,-2.46276 2.43139,-2.46276l15.79618,0c1.34903,0 2.43139,1.09805 2.43139,2.43139c0,0.01569 0,0.01569 0,0.03137l0,15.79618c0.01569,1.34903 -1.05099,2.44707 -2.40002,2.46276c-0.01569,0 -0.01569,0 -0.03137,0z",
    className: "st1",
    id: "svg_354"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m845.94327,452.49807l0.89412,0l1.80393,-2.69806l0.15686,-1.50589c0.03137,-0.20392 0.21961,-0.3451 0.42353,-0.31373c0.01569,0 0.04706,0 0.06275,0.01569c0.40785,0.18824 0.78432,0.70589 0.78432,2.21178l0,1.75687l2.80786,0.03137c0.3451,0.01569 0.62745,0.28235 0.64314,0.64314c0.03137,1.05099 0.07843,3.18433 0.07843,4.3765c0.03137,0.80001 -0.47059,1.52158 -1.23922,1.75687c-0.1098,0.03137 -0.21961,0.04706 -0.3451,0.03137c-0.75295,0 -4.53336,-0.59608 -4.53336,-0.59608l-1.56864,0l0.03137,-5.70984z",
    className: "st5",
    id: "svg_353"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.4,
    className: "st12",
    transform: "translate(328.317 164.653)",
    id: "svg_351"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.4,
    d: "m328.04192,194.22191l0.56471,5.80396l1.83531,0l0,-5.80396l-2.40002,0z",
    className: "st13",
    id: "svg_352"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m997.17561,628.67175l-15.90598,0l0,-5.12944l15.90598,0c0.32941,0 0.59608,0.25098 0.59608,0.5804c0,0 0,0.01569 0,0.01569l0,3.89022c0.01569,0.32941 -0.2353,0.61177 -0.56471,0.62745c-0.01569,0.01569 -0.03137,0.01569 -0.03137,0.01569z",
    className: "st5",
    id: "svg_350"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m767.02512,591.38523l1.05099,-46.71402l10.96478,-3.26277l-13.33342,-22.35308c-1.39609,-2.36864 -3.92159,-3.84316 -6.66671,-3.93728l-17.06678,-0.64314l-16.73736,2.72943l0.07843,-1.19216l-17.11384,7.18436c-2.63531,1.09805 -4.34513,3.67061 -4.34513,6.50985l-0.03137,17.41188l15.52951,7.52946l-3.67061,10.4785l0,26.61978l51.34151,-0.36079z",
    className: "st1",
    id: "svg_349"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m769.0016,534.33389c-0.06275,0 -0.14118,-0.03137 -0.18824,-0.07843l-1.67844,-1.56864c-0.1098,-0.1098 -0.1098,-0.26667 0,-0.37647s0.26667,-0.1098 0.37647,0l1.67844,1.56864c0.1098,0.09412 0.1098,0.25098 0.01569,0.36079c0,0 -0.01569,0.01569 -0.01569,0.01569c-0.04706,0.04706 -0.1098,0.07843 -0.18824,0.07843z",
    className: "st5",
    id: "svg_348"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m767.40159,534.38095c-0.06275,0 -0.14118,-0.03137 -0.18824,-0.07843c-0.1098,-0.09412 -0.1098,-0.25098 -0.01569,-0.3451c0,-0.01569 0.01569,-0.01569 0.01569,-0.01569l1.56864,-1.67844c0.1098,-0.1098 0.26667,-0.1098 0.37647,0s0.1098,0.26667 0,0.37647l-1.56864,1.67844c-0.04706,0.03137 -0.12549,0.06275 -0.18824,0.06275z",
    className: "st5",
    id: "svg_347"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m736.73473,588.49894c-0.06275,0 -0.14118,-0.03137 -0.18824,-0.07843l-1.67844,-1.56864c-0.1098,-0.1098 -0.1098,-0.26667 0,-0.37647s0.26667,-0.1098 0.37647,0l1.67844,1.56864c0.1098,0.09412 0.1098,0.25098 0.01569,0.3451c0,0.01569 -0.01569,0.01569 -0.01569,0.01569c-0.04706,0.06275 -0.1098,0.07843 -0.18824,0.09412z",
    className: "st5",
    id: "svg_346"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m735.08766,588.546c-0.06275,0 -0.14118,-0.03137 -0.18824,-0.07843c-0.1098,-0.09412 -0.1098,-0.25098 -0.01569,-0.3451c0,-0.01569 0.01569,-0.01569 0.01569,-0.01569l1.56864,-1.64707c0.1098,-0.1098 0.26667,-0.1098 0.37647,0s0.1098,0.26667 0,0.37647l-1.56864,1.64707c-0.04706,0.03137 -0.1098,0.06275 -0.18824,0.06275z",
    className: "st5",
    id: "svg_345"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m749.87991,525.15736c-0.06275,0 -0.14118,-0.03137 -0.18824,-0.07843l-1.67844,-1.56864c-0.1098,-0.1098 -0.1098,-0.26667 0,-0.37647s0.26667,-0.1098 0.37647,0l0,0l1.67844,1.56864c0.1098,0.09412 0.1098,0.25098 0.01569,0.3451c0,0.01569 -0.01569,0.01569 -0.01569,0.01569c-0.06275,0.06275 -0.12549,0.07843 -0.18824,0.09412z",
    className: "st5",
    id: "svg_344"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m748.23284,525.20442c-0.06275,0 -0.14118,-0.03137 -0.18824,-0.07843c-0.1098,-0.09412 -0.1098,-0.25098 -0.01569,-0.3451c0,-0.01569 0.01569,-0.01569 0.01569,-0.01569l1.56864,-1.67844c0.1098,-0.1098 0.26667,-0.1098 0.37647,0s0.1098,0.26667 0,0.37647l0,0l-1.56864,1.67844c-0.04706,0.06275 -0.1098,0.06275 -0.18824,0.06275z",
    className: "st5",
    id: "svg_343"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m732.89157,534.36526c-1.11373,0 -2.02354,-0.90981 -2.02354,-2.02354s0.90981,-2.02354 2.02354,-2.02354s2.02354,0.90981 2.02354,2.02354c-0.01569,1.11373 -0.9255,2.02354 -2.02354,2.02354zm0,-3.48238c-0.80001,-0.03137 -1.47452,0.61177 -1.50589,1.41177s0.61177,1.47452 1.41177,1.50589c0.03137,0 0.06275,0 0.09412,0c0.80001,0.03137 1.47452,-0.61177 1.50589,-1.41177s-0.61177,-1.47452 -1.41177,-1.50589c-0.03137,0 -0.06275,0 -0.09412,0z",
    className: "st5",
    id: "svg_342"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m761.11135,576.89102c-0.14118,0 -0.25098,-0.1098 -0.26667,-0.25098c0,0 0,-0.01569 0,-0.01569c0.03137,-0.80001 -0.61177,-1.47452 -1.41177,-1.50589s-1.47452,0.61177 -1.50589,1.41177c0,0.03137 0,0.06275 0,0.09412c0,0.14118 -0.1098,0.26667 -0.26667,0.26667c-0.14118,0 -0.26667,-0.1098 -0.26667,-0.26667c-0.03137,-1.11373 0.84706,-2.03923 1.9608,-2.0706c1.11373,-0.03137 2.03923,0.84706 2.0706,1.9608c0,0.03137 0,0.07843 0,0.1098c-0.01569,0.15686 -0.15686,0.26667 -0.31373,0.26667z",
    className: "st5",
    id: "svg_341"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m714.61694,537.00057c-0.14118,0 -0.25098,-0.1098 -0.26667,-0.25098c0,0 0,-0.01569 0,-0.01569c0,-0.80001 -0.65883,-1.45883 -1.45883,-1.45883c-0.80001,0.01569 -1.44315,0.65883 -1.45883,1.45883c0,0.14118 -0.1098,0.26667 -0.26667,0.26667c-0.14118,0 -0.26667,-0.1098 -0.26667,-0.26667c0,-1.09805 0.89412,-1.99217 1.97648,-1.99217s1.99217,0.89412 1.99217,1.97648c0,0 0,0 0,0c0.01569,0.15686 -0.09412,0.26667 -0.25098,0.28235c0,0 0,0 0,0z",
    className: "st5",
    id: "svg_340"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m718.61696,587.98129c-1.11373,0 -2.02354,-0.90981 -2.02354,-2.02354s0.90981,-2.02354 2.02354,-2.02354s2.02354,0.90981 2.02354,2.02354c0,1.11373 -0.90981,2.00786 -2.02354,2.02354zm0,-3.451c-0.80001,0 -1.45883,0.65883 -1.45883,1.45883c0,0.80001 0.65883,1.45883 1.45883,1.45883c0.80001,0 1.45883,-0.65883 1.45883,-1.45883c0,-0.80001 -0.65883,-1.45883 -1.45883,-1.45883l0,0z",
    className: "st5",
    id: "svg_339"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m712.02869,528.07502l-3.70198,-1.2706c-0.14118,-0.04706 -0.21961,-0.18824 -0.18824,-0.3451s0.18824,-0.21961 0.3451,-0.18824l3.70198,1.23922c0.15686,0.04706 0.2353,0.21961 0.18824,0.36079c-0.04706,0.15686 -0.18824,0.25098 -0.3451,0.20392l0,0z",
    className: "st5",
    id: "svg_338"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m747.63676,532.60839l-3.89022,0c-0.14118,0 -0.26667,-0.1098 -0.26667,-0.26667c0,-0.14118 0.1098,-0.26667 0.26667,-0.26667l0,0l3.89022,0c0.14118,0 0.25098,0.1098 0.26667,0.25098c0,0 0,0.01569 0,0.01569c0.03137,0.15686 -0.07843,0.26667 -0.26667,0.26667z",
    className: "st5",
    id: "svg_337"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m756.20152,520.10634c-0.06275,0 -0.14118,-0.03137 -0.18824,-0.07843c-0.1098,-0.09412 -0.1098,-0.25098 -0.01569,-0.3451c0,-0.01569 0.01569,-0.01569 0.01569,-0.01569l2.77649,-2.77649c0.1098,-0.1098 0.26667,-0.1098 0.37647,0s0.1098,0.26667 0,0.37647l-2.77649,2.77649c-0.04706,0.03137 -0.12549,0.04706 -0.18824,0.06275z",
    className: "st5",
    id: "svg_336"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m735.35433,535.60448c-0.98824,0 -1.80393,-0.80001 -1.80393,-1.78825s0.80001,-1.80393 1.78825,-1.80393c0.98824,0 1.80393,0.80001 1.80393,1.78825c0,0 0,0 0,0c0,1.00393 -0.80001,1.80393 -1.78825,1.80393zm0,-3.48238c-0.9255,0 -1.67844,0.75295 -1.67844,1.67844s0.75295,1.67844 1.67844,1.67844c0.9255,0 1.67844,-0.75295 1.67844,-1.67844c0,-0.9255 -0.73726,-1.67844 -1.66276,-1.67844c0,0 -0.01569,0 -0.01569,0z",
    className: "st5",
    id: "svg_335"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m763.65255,578.09887l-0.1098,0c0,-0.9255 -0.75295,-1.67844 -1.67844,-1.67844s-1.67844,0.75295 -1.67844,1.67844l-0.1098,0c0,-0.98824 0.80001,-1.80393 1.78825,-1.80393c0.97256,-0.01569 1.78825,0.76863 1.80393,1.75687c-0.01569,0.01569 -0.01569,0.03137 -0.01569,0.04706z",
    className: "st5",
    id: "svg_334"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m717.15813,538.19274l-0.1098,0c0,-0.9255 -0.75295,-1.67844 -1.67844,-1.67844s-1.67844,0.75295 -1.67844,1.67844l-0.1098,0c0,-0.98824 0.80001,-1.80393 1.80393,-1.80393c0.97256,-0.01569 1.78825,0.76863 1.78825,1.75687c-0.01569,0.01569 -0.01569,0.03137 -0.01569,0.04706z",
    className: "st5",
    id: "svg_333"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m721.09541,589.22051c-0.98824,0 -1.80393,-0.80001 -1.80393,-1.80393s0.80001,-1.80393 1.80393,-1.80393c0.98824,0 1.80393,0.80001 1.80393,1.80393l0,0c-0.01569,0.98824 -0.81569,1.80393 -1.80393,1.80393zm0,-3.451c-0.9255,0 -1.67844,0.75295 -1.67844,1.67844c0,0.9255 0.75295,1.67844 1.67844,1.67844c0.9255,0 1.67844,-0.75295 1.67844,-1.67844l0,0c0,-0.9255 -0.75295,-1.67844 -1.67844,-1.67844l0,0z",
    className: "st5",
    id: "svg_332"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m753.09562,585.36166c-1.11373,0 -2.02354,-0.90981 -2.02354,-2.02354s0.90981,-2.02354 2.02354,-2.02354s2.02354,0.90981 2.02354,2.02354c0,1.11373 -0.89412,2.02354 -2.00786,2.02354c0,0 0,0 -0.01569,0zm0,-3.451c-0.80001,0.01569 -1.44315,0.65883 -1.45883,1.45883c-0.03137,0.80001 0.61177,1.47452 1.41177,1.50589s1.47452,-0.61177 1.50589,-1.41177c0,-0.03137 0,-0.06275 0,-0.09412c0.01569,-0.80001 -0.62745,-1.44315 -1.42746,-1.45883c0,0 -0.01569,0 -0.03137,0l0,0z",
    className: "st5",
    id: "svg_331"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m755.57406,586.60089c-0.98824,0 -1.80393,-0.80001 -1.80393,-1.78825c0,-0.98824 0.80001,-1.80393 1.78825,-1.80393c0.98824,0 1.80393,0.80001 1.80393,1.78825c0,0 0,0 0,0c0.01569,0.97256 -0.76863,1.78825 -1.75687,1.80393c0,0 -0.01569,0 -0.03137,0zm0,-3.451c-0.9255,0 -1.67844,0.75295 -1.67844,1.67844c0,0.9255 0.75295,1.67844 1.67844,1.67844c0.9255,0 1.67844,-0.75295 1.67844,-1.67844l0,0c0.01569,-0.90981 -0.72157,-1.66276 -1.63138,-1.67844c-0.01569,0 -0.03137,0 -0.04706,0l0,0z",
    className: "st5",
    id: "svg_330"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m710.30319,528.68679l-0.03137,0.1098l3.70198,1.23922l0.03137,-0.1098l-3.70198,-1.23922z",
    className: "st5",
    id: "svg_329"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m750.14658,533.7378l-3.93728,0l0,0.1098l3.93728,0l0,-0.1098z",
    className: "st5",
    id: "svg_328"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m761.40939,518.50633l-2.77649,2.77649l0.07843,0.07843l2.77649,-2.77649l-0.07843,-0.07843z",
    className: "st5",
    id: "svg_327"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m764.43687,560.54582c-0.07843,0 -0.15686,0 -0.21961,-0.03137c-0.25098,-0.06275 -0.4549,-0.20392 -0.59608,-0.40785c-0.14118,-0.20392 -0.18824,-0.47059 -0.1098,-0.70589c0.06275,-0.25098 0.20392,-0.4549 0.40785,-0.59608c0.20392,-0.14118 0.47059,-0.18824 0.70589,-0.1098c0.25098,0.04706 0.47059,0.18824 0.59608,0.40785c0.14118,0.20392 0.18824,0.47059 0.1098,0.70589c-0.04706,0.25098 -0.20392,0.4549 -0.40785,0.59608c-0.14118,0.07843 -0.31373,0.14118 -0.48628,0.14118zm0,-1.34903c-0.07843,0.01569 -0.15686,0.03137 -0.21961,0.07843c-0.07843,0.07843 -0.14118,0.15686 -0.18824,0.26667c-0.03137,0.09412 -0.01569,0.20392 0.03137,0.29804c0.07843,0.07843 0.15686,0.14118 0.26667,0.18824c0.09412,0.03137 0.20392,0.01569 0.29804,-0.03137c0.07843,-0.07843 0.14118,-0.15686 0.18824,-0.26667c0.03137,-0.09412 0.01569,-0.20392 -0.03137,-0.29804c-0.07843,-0.07843 -0.15686,-0.14118 -0.26667,-0.18824c-0.01569,-0.03137 -0.04706,-0.04706 -0.07843,-0.04706z",
    className: "st5",
    id: "svg_326"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m763.87216,588.76561c-0.07843,0 -0.15686,0 -0.21961,-0.03137c-0.25098,-0.04706 -0.4549,-0.20392 -0.59608,-0.40785c-0.28235,-0.42353 -0.17255,-1.00393 0.25098,-1.28628c0.01569,-0.01569 0.03137,-0.01569 0.04706,-0.03137c0.20392,-0.14118 0.47059,-0.18824 0.70589,-0.1098c0.25098,0.04706 0.47059,0.18824 0.59608,0.40785c0.14118,0.20392 0.18824,0.47059 0.1098,0.70589c-0.06275,0.2353 -0.21961,0.4549 -0.40785,0.59608c-0.14118,0.09412 -0.31373,0.15686 -0.48628,0.15686zm0,-1.3804c-0.07843,0.01569 -0.15686,0.03137 -0.21961,0.07843c-0.18824,0.1098 -0.25098,0.3451 -0.14118,0.51765c0.01569,0.01569 0.01569,0.03137 0.03137,0.04706c0.07843,0.07843 0.15686,0.14118 0.26667,0.18824c0.09412,0.03137 0.20392,0.01569 0.29804,-0.03137c0.07843,-0.07843 0.14118,-0.15686 0.18824,-0.26667c0.03137,-0.09412 0.01569,-0.20392 -0.03137,-0.29804c-0.07843,-0.07843 -0.15686,-0.14118 -0.26667,-0.18824c-0.03137,-0.04706 -0.07843,-0.06275 -0.12549,-0.04706z",
    className: "st5",
    id: "svg_325"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m719.58952,525.53383c-0.07843,0 -0.15686,0 -0.21961,-0.03137c-0.25098,-0.04706 -0.47059,-0.18824 -0.59608,-0.40785c-0.14118,-0.20392 -0.18824,-0.47059 -0.1098,-0.70589c0.04706,-0.25098 0.18824,-0.47059 0.40785,-0.59608c0.20392,-0.14118 0.47059,-0.18824 0.70589,-0.1098c0.25098,0.04706 0.47059,0.18824 0.59608,0.40785c0.14118,0.20392 0.18824,0.47059 0.1098,0.70589c-0.04706,0.25098 -0.18824,0.47059 -0.40785,0.59608c-0.12549,0.1098 -0.31373,0.15686 -0.48628,0.14118zm0,-1.34903c-0.07843,0.01569 -0.15686,0.03137 -0.21961,0.07843c-0.07843,0.07843 -0.14118,0.15686 -0.18824,0.26667c-0.03137,0.09412 -0.01569,0.20392 0.03137,0.29804c0.07843,0.07843 0.15686,0.14118 0.26667,0.18824c0.09412,0.03137 0.20392,0.01569 0.29804,-0.03137c0.09412,-0.06275 0.15686,-0.15686 0.18824,-0.26667c0.03137,-0.09412 0.01569,-0.20392 -0.03137,-0.29804c-0.07843,-0.07843 -0.15686,-0.14118 -0.26667,-0.18824c0,-0.04706 -0.03137,-0.04706 -0.07843,-0.04706z",
    className: "st5",
    id: "svg_324"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m762.11528,527.71424c-0.32941,0 -0.64314,-0.15686 -0.81569,-0.4549c-0.14118,-0.20392 -0.18824,-0.47059 -0.1098,-0.70589c0.06275,-0.25098 0.20392,-0.4549 0.40785,-0.59608c0.20392,-0.14118 0.47059,-0.18824 0.70589,-0.1098c0.25098,0.04706 0.47059,0.18824 0.59608,0.40785c0.14118,0.20392 0.18824,0.47059 0.1098,0.70589c-0.04706,0.25098 -0.18824,0.47059 -0.40785,0.59608c-0.14118,0.09412 -0.31373,0.14118 -0.48628,0.15686zm0,-1.39609c-0.07843,0.01569 -0.15686,0.03137 -0.21961,0.07843c-0.07843,0.07843 -0.14118,0.15686 -0.18824,0.26667c-0.03137,0.09412 -0.01569,0.20392 0.03137,0.29804c0.1098,0.18824 0.36079,0.26667 0.56471,0.15686c0.07843,-0.07843 0.14118,-0.15686 0.18824,-0.26667c0.03137,-0.09412 0.01569,-0.20392 -0.03137,-0.29804c-0.07843,-0.07843 -0.15686,-0.14118 -0.26667,-0.18824c0,-0.04706 -0.03137,-0.04706 -0.07843,-0.04706z",
    className: "st5",
    id: "svg_323"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FA9B9B",
    d: "m759.76233,753.84902l24.00015,0.59608l-9.58438,-6.85495c-1.58432,-1.16079 -2.57257,-2.98041 -2.651,-4.94121l-0.32941,-7.52946l-13.06675,0.07843l1.63138,18.6511z",
    className: "st14",
    id: "svg_322"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m762.41332,745.09602l0,-0.15686c-0.07843,-0.83138 0.51765,-1.58432 1.34903,-1.67844l7.67064,-1.12942l-0.07843,-1.53726l-12.80008,0l1.16079,12.72165l10.4785,-1.16079l-3.451,-1.3804c-2.4157,-0.89412 -4.09414,-3.1059 -4.32944,-5.67847z",
    className: "st7",
    id: "svg_321"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FA9B9B",
    d: "m716.48362,753.4098l10.8236,0l1.99217,-18.27463l-12.76871,0.03137l-0.04706,18.24325z",
    className: "st14",
    id: "svg_320"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m719.18167,750.33527l0.26667,-5.61572c0.04706,-0.75295 0.61177,-1.36471 1.34903,-1.45883l7.78044,-1.19216l0.18824,-1.56864l-12.17263,0.03137l-0.03137,12.95695l2.61962,-3.15296z",
    className: "st7",
    id: "svg_319"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m715.77773,591.16562l0,149.44409l14.03931,0l12.204,-121.85176c0.07843,-0.86275 0.83138,-1.49021 1.67844,-1.42746c0.75295,0.06275 1.36471,0.65883 1.42746,1.42746l12.98832,121.85176l14.03931,0l-5.05101,-149.44409l-51.32582,0z",
    className: "st1",
    id: "svg_318"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#3F4249",
    d: "m715.77773,591.16562l0,149.44409l14.03931,0l12.204,-121.85176c0.07843,-0.86275 0.83138,-1.49021 1.67844,-1.42746c0.75295,0.06275 1.36471,0.65883 1.42746,1.42746l12.98832,121.85176l14.03931,0l-5.05101,-149.44409l-51.32582,0z",
    className: "st15",
    id: "svg_317"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#3F4249",
    d: "m717.31499,746.9627l0.32941,-0.3451c2.60394,-2.50982 6.74514,-2.46276 9.28633,0.1098l0.18824,0.21961c0.61177,0.62745 0.95687,1.47452 0.97256,2.35296l0,1.42746c0,0.81569 0.12549,1.6157 0.37647,2.40002l1.16079,3.81179c0.29804,0.9255 0.4549,1.88236 0.4549,2.83923l0,0.48628c-0.03137,0.76863 -0.6902,1.3804 -1.45883,1.34903l-13.28636,0c-0.76863,0.03137 -1.42746,-0.54902 -1.45883,-1.31766c0,-0.01569 0,-0.01569 0,-0.03137l0,-0.18824c0,-1.12942 0.18824,-2.24315 0.56471,-3.29414l1.34903,-3.74904c0.31373,-0.84706 0.47059,-1.75687 0.48628,-2.651l0.03137,-1.08236c0.01569,-0.86275 0.39216,-1.70981 1.00393,-2.33727z",
    className: "st15",
    id: "svg_316"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m715.40126,740.59403l14.93343,0l0.29804,-3.07453l-15.2001,0l-0.03137,3.07453z",
    className: "st1",
    id: "svg_315"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m715.40126,740.59403l6.24318,0l0.15686,-3.07453l-6.36867,0l-0.03137,3.07453z",
    className: "st7",
    id: "svg_314"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.5,
    d: "m713.86399,760.10788l0,0.18824c0.03137,0.76863 0.6902,1.3804 1.45883,1.34903l13.28636,0c0.76863,0.03137 1.42746,-0.54902 1.45883,-1.31766c0,-0.01569 0,-0.01569 0,-0.03137l0,-0.48628c0,-0.18824 0,-0.37647 -0.03137,-0.56471l-16.12559,0c-0.04706,0.28235 -0.04706,0.56471 -0.04706,0.86275z",
    className: "st9",
    id: "svg_313"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#3F4249",
    d: "m758.08388,749.58232l0,9.36477c0,1.50589 1.20785,2.72943 2.71374,2.72943c0,0 0.01569,0 0.01569,0l31.82765,0c0.64314,0 1.16079,-0.51765 1.16079,-1.16079c-0.01569,-2.22747 -1.44315,-4.20395 -3.56081,-4.90984l-7.18436,-2.35296l-9.0981,-7.07456c-0.94118,-0.73726 -2.27452,-0.70589 -3.18433,0.07843l-4.04708,3.451c-0.5804,0.50196 -1.39609,0.67451 -2.13335,0.4549l-5.09807,-1.56864c-0.5804,-0.17255 -1.19216,0.14118 -1.3804,0.72157c-0.01569,0.07843 -0.03137,0.17255 -0.03137,0.26667z",
    className: "st15",
    id: "svg_312"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "m760.81331,761.70789l31.81197,0c0.64314,0 1.16079,-0.51765 1.16079,-1.16079c0,-0.39216 -0.04706,-0.78432 -0.15686,-1.16079l-35.51395,0c0.21961,1.33334 1.34903,2.3059 2.69806,2.32158z",
    id: "svg_311"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m773.75457,749.92742c-0.06275,0 -0.14118,-0.03137 -0.18824,-0.07843c-0.1098,-0.1098 -0.1098,-0.29804 0,-0.40785l1.91374,-2.05492c0.1098,-0.1098 0.29804,-0.1098 0.40785,0.01569c0.1098,0.1098 0.1098,0.28235 0,0.40785l-1.91374,2.05492c-0.06275,0.03137 -0.12549,0.04706 -0.21961,0.06275z",
    className: "st5",
    id: "svg_310"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m775.29184,751.11959c-0.06275,0 -0.14118,-0.03137 -0.18824,-0.07843c-0.1098,-0.1098 -0.1098,-0.29804 0,-0.40785l1.91374,-2.05492c0.1098,-0.12549 0.29804,-0.12549 0.40785,-0.03137c0.12549,0.1098 0.12549,0.29804 0.03137,0.40785c-0.01569,0.01569 -0.01569,0.01569 -0.03137,0.03137l-1.91374,2.05492c-0.06275,0.04706 -0.14118,0.07843 -0.21961,0.07843z",
    className: "st5",
    id: "svg_309"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m776.79773,752.31175c-0.06275,0 -0.14118,-0.03137 -0.18824,-0.07843c-0.1098,-0.1098 -0.1098,-0.29804 0,-0.40785l1.91374,-2.05492c0.1098,-0.1098 0.29804,-0.1098 0.40785,0.01569c0.1098,0.1098 0.1098,0.28235 0,0.40785l-1.91374,2.05492c-0.06275,0.04706 -0.14118,0.07843 -0.21961,0.06275z",
    className: "st5",
    id: "svg_308"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m724.68759,750.11566c-0.06275,0 -0.1098,0 -0.15686,-0.03137c-1.53726,-0.73726 -3.32551,-0.73726 -4.86278,0c-0.17255,0.07843 -0.36079,0.01569 -0.4549,-0.15686c-0.07843,-0.17255 -0.01569,-0.36079 0.15686,-0.4549c1.7255,-0.86275 3.76473,-0.86275 5.50592,0c0.15686,0.09412 0.21961,0.28235 0.15686,0.4549c-0.07843,0.1098 -0.20392,0.18824 -0.3451,0.18824z",
    className: "st5",
    id: "svg_307"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m724.68759,751.82547c-0.06275,0 -0.1098,0 -0.15686,-0.03137c-1.53726,-0.73726 -3.32551,-0.73726 -4.86278,0c-0.17255,0.07843 -0.36079,0.01569 -0.4549,-0.15686c-0.07843,-0.17255 -0.01569,-0.36079 0.15686,-0.4549c1.7255,-0.86275 3.76473,-0.86275 5.50592,0c0.15686,0.09412 0.21961,0.28235 0.15686,0.4549c-0.07843,0.12549 -0.20392,0.18824 -0.3451,0.18824z",
    className: "st5",
    id: "svg_306"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m724.68759,753.47254c-0.06275,0 -0.1098,0 -0.15686,-0.03137c-1.53726,-0.73726 -3.32551,-0.73726 -4.86278,0c-0.17255,0.07843 -0.36079,-0.01569 -0.43922,-0.17255c-0.06275,-0.15686 0,-0.32941 0.14118,-0.42353c1.7255,-0.86275 3.76473,-0.86275 5.50592,0c0.15686,0.09412 0.21961,0.28235 0.15686,0.4549c-0.07843,0.1098 -0.20392,0.17255 -0.3451,0.17255z",
    className: "st5",
    id: "svg_305"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.2,
    d: "m766.42903,738.91559l-13.85107,-115.04387c-0.43922,-3.6863 -3.57649,-6.46279 -7.29416,-6.47847l-1.7255,0c0.80001,0 1.47452,0.62745 1.53726,1.42746l12.90989,121.17725l8.42358,-1.08236z",
    className: "st16",
    id: "svg_304"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m757.70741,740.59403l14.90206,0l-0.21961,-3.07453l-14.98049,0l0.29804,3.07453z",
    className: "st1",
    id: "svg_303"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m757.70741,740.59403l8.87849,0l-0.32941,-3.07453l-8.83143,0l0.28235,3.07453z",
    className: "st7",
    id: "svg_302"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.15,
    className: "st17",
    transform: "translate(257.033 255.028)",
    id: "svg_300"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.4,
    d: "m359.79114,194.81799l-31.45118,0c-0.15686,0 -0.29804,-0.12549 -0.29804,-0.28235c0,0 0,0 0,-0.01569c0.01569,-0.15686 0.14118,-0.28235 0.29804,-0.29804l31.45118,0c0.17255,0 0.29804,0.14118 0.29804,0.29804c0,0.17255 -0.14118,0.29804 -0.29804,0.29804l0,0l0,0z",
    className: "st13",
    id: "svg_301"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.2,
    d: "m715.77773,591.46366l0,145.99309l6.02357,0.03137l1.2706,-146.04015l-7.29416,0.01569z",
    className: "st16",
    id: "svg_299"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FA9B9B",
    d: "m742.20927,497.09443c0,0 -15.09029,-9.47457 -15.68637,2.10197l-0.21961,2.9961l-1.00393,15.01186l0,0.18824c0,0.42353 0.14118,0.83138 0.40785,1.16079l8.72162,5.94514c0.26667,0.17255 0.61177,0.15686 0.86275,-0.03137l6.47847,-5.50592c0.43922,-0.37647 0.67451,-0.95687 0.59608,-1.53726l-0.21961,-2.21178l-0.70589,-6.77651c0.20392,-0.87844 0.29804,-1.75687 0.29804,-2.651c0.04706,-4.58042 0.47059,-8.69025 0.47059,-8.69025z",
    className: "st14",
    id: "svg_298"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m743.5583,497.80032c2.80786,0 5.09807,-2.27452 5.09807,-5.09807s-2.27452,-5.09807 -5.09807,-5.09807s-5.09807,2.27452 -5.09807,5.09807c0,2.82355 2.27452,5.09807 5.09807,5.09807z",
    className: "st4",
    id: "svg_297"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FA9B9B",
    d: "m743.91909,488.89046c0,0 5.34905,22.49426 -6.18043,24.03153c-9.99222,1.34903 -11.07458,-14.25891 -11.07458,-14.25891l0.48628,-10.10203l16.76873,0.32941z",
    className: "st14",
    id: "svg_296"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m743.26026,490.31792l-10.22752,0.75295c-1.25491,0.1098 -2.19609,1.20785 -2.13335,2.47845c0.09412,1.2706 -0.86275,2.36864 -2.13335,2.46276c0,0 0,0 0,0c-0.3451,0.04706 -0.59608,0.32941 -0.59608,0.67451l0.15686,2.24315c0.03137,0.26667 -0.15686,0.51765 -0.42353,0.54902c-0.01569,0 -0.04706,0 -0.06275,0c-0.26667,0.03137 -0.50196,-0.15686 -0.56471,-0.40785l-0.4549,-2.13335l-0.4549,-0.70589l-2.40002,1.49021c0,0 -3.89022,-5.9922 -2.02354,-11.45105c0.94118,-2.38433 3.07453,-4.07846 5.61572,-4.42356c0.47059,-0.06275 0.90981,-0.3451 1.16079,-0.75295c1.08236,-1.81962 3.13727,-2.85492 5.23925,-2.61962c1.85099,0.01569 3.56081,0.95687 4.56474,2.50982c0.42353,0.64314 1.25491,0.87844 1.94511,0.56471c1.41177,-0.65883 3.05884,-0.53334 4.34513,0.32941c3.30983,2.11766 1.99217,7.87456 -1.55295,8.43927z",
    className: "st4",
    id: "svg_295"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m726.30329,502.92976c0.51765,0.04706 1.05099,-0.07843 1.49021,-0.32941l-1.64707,2.50982l0.15686,-2.18041z",
    className: "st7",
    id: "svg_294"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FA9B9B",
    d: "m726.85231,496.93757c-0.37647,-1.09805 -1.56864,-1.66276 -2.66668,-1.28628c-0.09412,0.03137 -0.20392,0.07843 -0.29804,0.12549c-2.50982,1.12942 -1.99217,6.80789 2.24315,7.15299c2.21178,0.18824 1.78825,-1.12942 1.42746,-2.83923l-0.70589,-3.15296z",
    className: "st14",
    id: "svg_293"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.3,
    d: "m723.79347,497.26698c0.3451,-0.26667 0.80001,-0.39216 1.23922,-0.32941c0.42353,0.1098 0.78432,0.39216 0.97256,0.78432c0.26667,0.47059 0.40785,0.98824 0.40785,1.53726l0.03137,0.48628c0,0.14118 -0.1098,0.26667 -0.26667,0.26667c-0.14118,0 -0.26667,-0.1098 -0.26667,-0.26667l-0.03137,-0.48628c-0.01569,-0.4549 -0.12549,-0.90981 -0.32941,-1.30197c-0.17255,-0.47059 -0.6902,-0.70589 -1.16079,-0.53334c-0.1098,0.04706 -0.21961,0.1098 -0.31373,0.18824c-0.12549,0.07843 -0.28235,0.04706 -0.37647,-0.07843c-0.06275,0 -0.01569,-0.14118 0.09412,-0.26667z",
    className: "st18",
    id: "svg_292"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FA9B9B",
    d: "m743.323,490.8042l-1.19216,0.1098c-0.14118,0.01569 -0.25098,-0.09412 -0.26667,-0.21961c0,-0.15686 0.07843,-0.26667 0.21961,-0.26667l1.19216,-0.1098c0.15686,0 0.29804,-0.03137 0.4549,-0.07843c0.48628,-0.15686 0.95687,-0.39216 1.3804,-0.67451c0.1098,-0.07843 0.26667,-0.06275 0.3451,0.04706s0.06275,0.26667 -0.04706,0.3451c-0.01569,0.01569 -0.03137,0.01569 -0.03137,0.03137c-0.4549,0.31373 -0.97256,0.54902 -1.49021,0.70589l-0.56471,0.1098z",
    className: "st14",
    id: "svg_291"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m742.05241,514.75729l-0.37647,-3.59218c-1.86668,1.63138 -4.40787,2.24315 -6.80789,1.64707l0,0c-1.58432,-0.39216 -2.9961,-1.2706 -4.04708,-2.50982c-0.07843,-0.1098 -0.2353,-0.12549 -0.32941,-0.04706s-0.12549,0.2353 -0.04706,0.32941c0,0 0,0 0,0c3.38826,2.49413 7.41966,3.92159 11.60792,4.17258l0,0z",
    className: "st7",
    id: "svg_290"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.3,
    className: "st19",
    transform: "translate(260.589 199.829)",
    id: "svg_288"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.3,
    d: "m329.79879,194.86505c0,0.03137 -0.03137,0.03137 0,0c-0.97256,0.06275 -1.41177,0.1098 -1.41177,0.1098c-0.17255,0 -0.32941,-0.12549 -0.3451,-0.29804c-0.01569,-0.17255 0.1098,-0.32941 0.28235,-0.32941c0,0 0,0 0.01569,0l1.39609,-0.12549c0.17255,-0.01569 0.31373,0.09412 0.32941,0.26667c0,0.21961 -0.1098,0.37647 -0.26667,0.37647z",
    className: "st18",
    id: "svg_289"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.3,
    className: "st19",
    transform: "translate(259.42 198.04)",
    id: "svg_286"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.3,
    d: "m332.16743,196.35525c-1.58432,0.36079 -3.21571,-0.31373 -4.07846,-1.67844c-0.09412,-0.15686 -0.03137,-0.32941 0.1098,-0.42353s0.32941,-0.03137 0.40785,0.1098l0,0c0.37647,0.67451 1.6157,2.10197 4.64317,1.12942c0.15686,-0.04706 0.31373,0.04706 0.36079,0.20392c0.03137,0.14118 -0.03137,0.29804 -0.17255,0.3451c-0.40785,0.15686 -0.84706,0.26667 -1.2706,0.31373z",
    className: "st18",
    id: "svg_287"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m735.62099,500.34151c0.51765,0 0.94118,-0.42353 0.94118,-0.94118c0,-0.51765 -0.42353,-0.94118 -0.94118,-0.94118c-0.51765,0 -0.94118,0.42353 -0.94118,0.94118c0.01569,0.51765 0.42353,0.9255 0.94118,0.94118z",
    className: "st4",
    id: "svg_285"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m736.02884,499.29053c0.1098,0 0.18824,-0.07843 0.18824,-0.18824s-0.07843,-0.18824 -0.18824,-0.18824c-0.1098,0 -0.18824,0.07843 -0.18824,0.18824l0,0c0,0.09412 0.06275,0.18824 0.17255,0.18824c0,0 0.01569,0 0.01569,0z",
    className: "st5",
    id: "svg_284"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m742.96222,500.38857c0.51765,0 0.94118,-0.42353 0.94118,-0.94118c0,-0.51765 -0.42353,-0.94118 -0.94118,-0.94118c-0.51765,0 -0.94118,0.42353 -0.94118,0.94118c-0.01569,0.51765 0.40785,0.94118 0.90981,0.94118c0.01569,0 0.01569,0 0.03137,0z",
    className: "st4",
    id: "svg_283"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m743.37006,499.33758c0.1098,0 0.18824,-0.07843 0.18824,-0.18824s-0.07843,-0.18824 -0.18824,-0.18824c-0.1098,0 -0.18824,0.07843 -0.18824,0.18824l0,0c0,0.09412 0.06275,0.18824 0.17255,0.18824c0,0 0,0 0.01569,0z",
    className: "st5",
    id: "svg_282"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.3,
    className: "st19",
    transform: "translate(261.496 196.535)",
    id: "svg_280"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.3,
    d: "m329.57918,196.46506l-1.23922,0.07843c-0.15686,0.01569 -0.28235,-0.1098 -0.29804,-0.26667c-0.01569,-0.15686 0.1098,-0.28235 0.26667,-0.29804l1.23922,-0.07843c0.31373,-0.03137 0.53334,-0.31373 0.50196,-0.61177c-0.03137,-0.29804 -0.28235,-0.51765 -0.5804,-0.50196c-0.15686,0 -0.28235,-0.1098 -0.29804,-0.26667c-0.04706,-0.15686 0.1098,-0.26667 0.25098,-0.29804c0.59608,-0.03137 1.12942,0.40785 1.19216,1.00393c0.04706,0.62745 -0.40785,1.17648 -1.0353,1.23922z",
    className: "st18",
    id: "svg_281"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m745.56616,497.04737l-12.69028,0c-0.73726,0 -1.34903,0.59608 -1.34903,1.33334c0,0 0,0 0,0.01569l0,1.05099c0,2.00786 1.63138,3.63924 3.63924,3.63924s3.63924,-1.63138 3.63924,-3.63924l0,-1.05099c0,-0.29804 -0.1098,-0.59608 -0.29804,-0.81569l1.42746,0c-0.18824,0.2353 -0.26667,0.53334 -0.26667,0.81569l0,1.05099c0,2.00786 1.63138,3.63924 3.63924,3.63924s3.63924,-1.63138 3.63924,-3.63924l0,-1.05099c-0.01569,-0.73726 -0.62745,-1.34903 -1.3804,-1.34903c0.01569,0 0.01569,0 0,0zm-7.29416,1.34903l0,1.05099c0.01569,1.70981 -1.36471,3.09022 -3.07453,3.1059s-3.09022,-1.36471 -3.1059,-3.07453l0,-1.05099c0,-0.4549 0.37647,-0.81569 0.81569,-0.81569l4.59611,0c0.42353,0 0.75295,0.3451 0.75295,0.75295c0.03137,0.01569 0.03137,0.03137 0.01569,0.03137l0,0zm8.12554,1.00393c0.01569,1.70981 -1.36471,3.09022 -3.07453,3.1059s-3.09022,-1.36471 -3.1059,-3.07453l0,0l0,-1.05099c0,-0.4549 0.37647,-0.81569 0.81569,-0.81569l4.61179,0c0.4549,0 0.81569,0.37647 0.81569,0.81569l-0.06275,1.01961z",
    className: "st4",
    id: "svg_279"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FA9B9B",
    d: "m703.90314,546.88299l0.03137,27.37272l11.01184,-1.08236l5.80396,-26.27468l-16.84717,-0.01569z",
    className: "st14",
    id: "svg_278"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FA9B9B",
    d: "m712.21692,559.52621l3.67061,-5.01964l2.69806,-10.9334c0.12549,-0.51765 0.32941,-1.01961 0.64314,-1.45883c0.43922,-0.5804 1.01961,-1.0353 1.67844,-1.30197l9.01967,-4.34513c0.5804,-0.26667 1.2706,-0.03137 1.56864,0.51765c0.31373,0.56471 0.1098,1.25491 -0.4549,1.56864l-7.52946,4.59611l6.77651,-2.16472c0.62745,-0.18824 1.28628,0.15686 1.47452,0.78432c0.03137,0.12549 0.06275,0.25098 0.04706,0.37647c-0.03137,0.43922 -0.28235,0.81569 -0.67451,1.00393l-7.93731,3.37257l6.02357,-2.54119c0.54902,-0.2353 1.17648,0.03137 1.41177,0.5804c0.06275,0.14118 0.07843,0.28235 0.07843,0.42353c0.01569,0.37647 -0.18824,0.72157 -0.51765,0.89412l-6.50985,3.96865l4.29807,-2.58825c0.4549,-0.26667 1.0353,-0.12549 1.31766,0.32941c0.04706,0.07843 0.09412,0.17255 0.1098,0.26667c0.06275,0.31373 -0.01569,0.64314 -0.21961,0.89412l-3.70198,3.70198l-7.90593,24.10996c-2.0706,4.90984 -5.36474,-17.0354 -5.36474,-17.0354z",
    className: "st14",
    id: "svg_277"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FA9B9B",
    d: "m711.3228,561.62818l-5.94514,7.8275c-2.36864,3.12159 -1.74119,7.56083 1.3804,9.92948c3.12159,2.36864 7.56083,1.74119 9.92948,-1.3804c0.3451,-0.4549 0.62745,-0.95687 0.86275,-1.47452l3.56081,-10.74517l-9.7883,-4.15689z",
    className: "st14",
    id: "svg_276"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m715.8091,554.31833l2.77649,-10.90203c0.26667,-1.05099 0.97256,-1.91374 1.94511,-2.40002l1.05099,-0.51765l0.03137,-0.89412l-2.35296,1.12942c-1.01961,0.48628 -1.77256,1.41177 -2.02354,2.50982l-2.47845,10.71379l-10.52556,13.4746l-0.26667,4.10983l11.84321,-17.22364z",
    className: "st7",
    id: "svg_275"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FA9B9B",
    d: "m779.00951,541.1104l9.31771,15.41971l-15.38833,2.69806l-6.93338,-14.33735l13.004,-3.78042z",
    className: "st14",
    id: "svg_274"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m766.27217,545.34572l0.75295,0.26667l0.70589,-3.56081l-3.85885,0.97256l2.40002,2.32158z",
    className: "st4",
    id: "svg_273"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m728.76605,541.48687l-0.64314,-1.12942l1.53726,-0.94118l-0.37647,1.86668l-0.51765,0.20392z",
    className: "st4",
    id: "svg_272"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m726.82094,538.0045l-4.29807,-7.59221c-0.25098,-0.47059 -0.1098,-1.05099 0.32941,-1.34903c0.43922,-0.28235 1.0353,-0.15686 1.33334,0.28235c0.01569,0.03137 0.03137,0.06275 0.04706,0.09412l4.45493,7.7177l-1.86668,0.84706z",
    className: "st4",
    id: "svg_271"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.15,
    className: "st17",
    transform: "translate(251.955 222.888)",
    id: "svg_269"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m328.33996,197.01408c-0.12549,0 -0.21961,-0.07843 -0.26667,-0.18824c-0.06275,-0.14118 0,-0.29804 0.12549,-0.36079c0.01569,0 0.01569,-0.01569 0.03137,-0.01569l5.16082,-2.19609c0.14118,-0.07843 0.31373,-0.01569 0.39216,0.12549c0.07843,0.14118 0.01569,0.31373 -0.12549,0.37647c-0.01569,0 -0.01569,0.01569 -0.03137,0.01569l-5.1765,2.21178c-0.03137,0.03137 -0.07843,0.04706 -0.1098,0.03137z",
    className: "st7",
    id: "svg_270"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m723.5268,543.13394l4.45493,-1.42746l0.29804,0.64314l-4.75297,0.78432z",
    className: "st7",
    id: "svg_268"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.15,
    className: "st17",
    transform: "translate(252.356 224.887)",
    id: "svg_266"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m328.30858,197.1082c-0.09412,0 -0.18824,-0.06275 -0.21961,-0.15686c-0.07843,-0.12549 -0.03137,-0.28235 0.07843,-0.36079c0.01569,0 0.01569,-0.01569 0.03137,-0.01569l3.85885,-2.32158c0.12549,-0.07843 0.28235,-0.03137 0.36079,0.09412c0,0 0,0.01569 0.01569,0.01569c0.07843,0.12549 0.04706,0.28235 -0.07843,0.36079c-0.01569,0 -0.01569,0.01569 -0.03137,0.01569l-3.87453,2.32158c-0.06275,0 -0.1098,0.04706 -0.14118,0.04706z",
    className: "st7",
    id: "svg_267"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m757.28388,531.25936l1.7255,4.59611c0.07843,0.21961 -0.03137,0.4549 -0.25098,0.53334c-0.04706,0.01569 -0.07843,0.03137 -0.12549,0.03137l-1.91374,0c-0.21961,0 -0.40785,-0.18824 -0.40785,-0.40785l0.18824,-4.59611c0.01569,-0.21961 0.20392,-0.40785 0.42353,-0.39216c0.15686,0 0.29804,0.09412 0.36079,0.2353z",
    className: "st7",
    id: "svg_265"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m721.58169,540.51432l0.15686,-7.26279c0,-0.2353 0.20392,-0.43922 0.4549,-0.42353c0.18824,0 0.36079,0.12549 0.40785,0.31373l1.80393,6.02357l-2.82355,1.34903z",
    className: "st7",
    id: "svg_264"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.6,
    d: "m742.00535,514.45925l0.29804,2.96472c0.07843,0.5804 -0.15686,1.16079 -0.59608,1.53726l-6.47847,5.50592c-0.25098,0.20392 -0.59608,0.21961 -0.86275,0.03137l-8.72162,-5.94514c-0.26667,-0.32941 -0.42353,-0.73726 -0.40785,-1.16079l0.1098,-1.34903l-2.16472,0.94118l0,1.56864c0.09412,0.31373 0.29804,0.59608 0.56471,0.78432l10.29026,7.23142c0.53334,0.37647 1.2706,0.32941 1.75687,-0.1098l8.04711,-7.15299c0.3451,-0.28235 0.51765,-0.72157 0.48628,-1.16079l-0.37647,-3.51375l-1.94511,-0.17255z",
    className: "st20",
    id: "svg_263"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.6,
    d: "m703.90314,546.8673l12.47067,0l0.48628,-2.05492l-12.90989,0l0,2.05492l-0.04706,0z",
    className: "st20",
    id: "svg_262"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.6,
    d: "m779.00951,541.1104l-1.19216,-2.05492l-10.07065,2.96472l-0.48628,2.50982l11.74909,-3.41963z",
    className: "st20",
    id: "svg_261"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m757.95839,534.06722l-5.64709,0c-0.47059,-1.17648 -1.6157,-1.9608 -2.88629,-1.94511c-1.11373,0.01569 -2.03923,0.84706 -2.16472,1.94511l-4.8314,0c-0.37647,0 -0.70589,0.26667 -0.78432,0.64314l-1.6157,6.58828c-0.1098,0.43922 0.15686,0.87844 0.59608,0.98824c0.06275,0.01569 0.12549,0.01569 0.18824,0.01569l15.52951,0c0.37647,0 0.70589,-0.26667 0.78432,-0.64314l1.6157,-6.58828c0.1098,-0.43922 -0.15686,-0.87844 -0.59608,-0.98824c-0.06275,0 -0.12549,-0.01569 -0.18824,-0.01569z",
    className: "st4",
    id: "svg_260"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#3F4249",
    d: "m758.4133,536.43586l0.32941,-1.34903c0.1098,-0.43922 -0.15686,-0.87844 -0.59608,-0.98824c-0.06275,-0.01569 -0.12549,-0.01569 -0.18824,-0.01569l-5.64709,0c-0.47059,-1.17648 -1.6157,-1.9608 -2.88629,-1.94511c-1.11373,0.01569 -2.03923,0.84706 -2.16472,1.94511l-4.8314,0c-0.37647,0 -0.70589,0.26667 -0.78432,0.64314l-0.4549,1.75687l17.22364,0l0,-0.04706z",
    className: "st15",
    id: "svg_259"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m752.12306,533.7378l-4.8314,0c-0.03137,0.1098 -0.03137,0.18824 -0.07843,0.29804l5.01964,0c0,-0.1098 -0.04706,-0.21961 -0.1098,-0.29804z",
    className: "st4",
    id: "svg_258"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#3F4249",
    d: "m721.12678,583.04008l33.99237,0c1.63138,0 3.02747,-1.14511 3.37257,-2.72943l8.56476,-42.11792c0.15686,-0.80001 -0.37647,-1.58432 -1.17648,-1.74119c-0.09412,-0.01569 -0.18824,-0.03137 -0.28235,-0.03137l-33.99237,0c-1.63138,0 -3.02747,1.14511 -3.37257,2.72943l-8.56476,42.11792c-0.14118,0.81569 0.40785,1.60001 1.22354,1.74119c0.07843,0.01569 0.15686,0.03137 0.2353,0.03137z",
    className: "st15",
    id: "svg_257"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m722.58562,583.04008l33.99237,0c1.63138,0 3.02747,-1.14511 3.37257,-2.72943l8.56476,-42.11792c0.15686,-0.80001 -0.37647,-1.58432 -1.17648,-1.74119c-0.09412,-0.01569 -0.18824,-0.03137 -0.28235,-0.03137l-33.99237,0c-1.63138,0 -3.02747,1.14511 -3.37257,2.72943l-8.56476,42.11792c-0.15686,0.80001 0.37647,1.58432 1.17648,1.74119c0.09412,0.01569 0.18824,0.03137 0.28235,0.03137z",
    className: "st4",
    id: "svg_256"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FA9B9B",
    d: "m774.47615,548.26339l-2.43139,1.3804l-4.7216,-3.70198c-0.50196,-0.39216 -1.09805,-0.65883 -1.7255,-0.75295c-0.64314,-0.06275 -1.30197,0.01569 -1.91374,0.21961l-9.58438,2.96472c-0.61177,0.20392 -0.94118,0.84706 -0.78432,1.45883c0.14118,0.62745 0.75295,1.01961 1.3804,0.87844c0.01569,0 0.03137,0 0.04706,-0.01569l8.56476,-1.78825l-6.43141,3.02747c-0.5804,0.28235 -0.83138,0.98824 -0.54902,1.56864c0.04706,0.1098 0.12549,0.21961 0.20392,0.29804c0.31373,0.31373 0.76863,0.42353 1.19216,0.29804l8.07848,-2.91767l-6.18043,2.24315c-0.56471,0.20392 -0.84706,0.81569 -0.64314,1.3804c0.04706,0.14118 0.12549,0.26667 0.2353,0.37647c0.26667,0.26667 0.64314,0.39216 1.00393,0.32941l7.93731,-1.64707l-5.39611,1.12942c-0.50196,0.07843 -0.84706,0.56471 -0.75295,1.06667c0.01569,0.1098 0.06275,0.21961 0.12549,0.31373c0.15686,0.28235 0.4549,0.47059 0.78432,0.48628l5.23925,0.18824l5.91376,6.99612c2.7608,3.3412 7.57652,4.1412 11.26282,1.86668c0.12549,-0.07843 0.25098,-0.17255 0.37647,-0.26667l0.21961,-0.15686c2.40002,-4.75297 -11.45105,-17.22364 -11.45105,-17.22364z",
    className: "st14",
    id: "svg_255"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FA9B9B",
    d: "m774.47615,548.26339l8.72162,4.42356c3.85885,0.67451 6.43141,4.36081 5.7569,8.21966c-0.67451,3.85885 -4.36081,6.43141 -8.21966,5.7569c-0.54902,-0.09412 -1.09805,-0.26667 -1.6157,-0.48628l-5.42749,-5.34905l0.78432,-12.56479z",
    className: "st14",
    id: "svg_254"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m772.04476,549.64379l-4.8314,-3.78042l4.7216,2.35296l13.20793,2.9961l2.21178,3.81179l-15.3099,-5.38043z",
    className: "st7",
    id: "svg_253"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.15,
    className: "st17",
    transform: "translate(276.722 229.254)",
    id: "svg_251"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m334.44196,194.44152c-0.04706,-0.14118 -0.18824,-0.2353 -0.32941,-0.21961l-4.26669,0.86275l-1.09805,0.21961c-0.3451,0.06275 -0.62745,0.32941 -0.70589,0.67451l6.18043,-1.23922c0.14118,0 0.21961,-0.14118 0.21961,-0.29804z",
    className: "st7",
    id: "svg_252"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m766.02119,551.63596c0.14118,-0.04706 0.20392,-0.20392 0.15686,-0.32941c-0.04706,-0.14118 -0.20392,-0.20392 -0.32941,-0.15686l-2.80786,1.05099l2.83923,-1.05099l-3.29414,1.19216l-3.02747,1.12942c-0.28235,0.15686 -0.47059,0.43922 -0.51765,0.75295l0.07843,0l6.902,-2.58825z",
    className: "st7",
    id: "svg_250"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m872.62579,621.56582c0.09412,0 0.18824,-0.06275 0.18824,-0.17255c0,0 0,-0.01569 0,-0.01569c0.01569,-1.30197 1.05099,-2.33727 2.35296,-2.35296l1.12942,0c0.98824,0 1.80393,-0.80001 1.80393,-1.80393c-0.01569,-0.98824 -0.81569,-1.78825 -1.80393,-1.80393l-6.43141,0c-0.80001,0 -1.45883,-0.65883 -1.45883,-1.45883c0.01569,-0.80001 0.65883,-1.44315 1.45883,-1.45883l1.53726,0c1.00393,0.01569 1.81962,-0.78432 1.83531,-1.78825c0,-0.01569 0,-0.03137 0,-0.04706c0,-0.1098 -0.07843,-0.18824 -0.18824,-0.18824s-0.18824,0.07843 -0.18824,0.18824c0,0.83138 -0.67451,1.49021 -1.50589,1.50589l-1.53726,0c-0.97256,-0.01569 -1.78825,0.76863 -1.80393,1.75687c0,0.01569 0,0.03137 0,0.04706c0,0.98824 0.80001,1.80393 1.80393,1.80393l6.43141,0c0.80001,0.03137 1.44315,0.70589 1.41177,1.50589c-0.03137,0.76863 -0.64314,1.3804 -1.41177,1.41177l-1.12942,0c-1.49021,0 -2.68237,1.20785 -2.69806,2.69806c0.01569,0.12549 0.09412,0.17255 0.20392,0.17255z",
    className: "st5",
    id: "svg_249"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m868.92381,622.60112c0.09412,0 0.18824,-0.06275 0.18824,-0.17255c0,0 0,-0.01569 0,-0.01569l0,-0.40785c0,-0.28235 0.21961,-0.51765 0.50196,-0.51765c0.01569,0 0.01569,0 0.03137,0c0.47059,0 0.86275,-0.39216 0.86275,-0.86275l0,-0.70589c0,-0.47059 -0.39216,-0.86275 -0.86275,-0.86275l-1.08236,0c-1.45883,0 -2.651,-1.19216 -2.651,-2.651l0,-1.31766c0.01569,-0.09412 -0.06275,-0.17255 -0.15686,-0.18824c0,0 0,0 0,0c-0.09412,0 -0.18824,0.06275 -0.18824,0.17255c0,0 0,0.01569 0,0.01569l0,1.2706c0,1.64707 1.34903,2.9961 2.9961,2.9961l1.08236,0c0.28235,0 0.51765,0.21961 0.51765,0.50196c0,0.01569 0,0.01569 0,0.03137l0,0.70589c0,0.28235 -0.21961,0.51765 -0.50196,0.51765c-0.01569,0 -0.01569,0 -0.03137,0c-0.47059,0 -0.86275,0.39216 -0.86275,0.86275l0,0.40785c-0.03137,0.07843 0.01569,0.17255 0.09412,0.20392c0.01569,0.01569 0.04706,0.01569 0.06275,0.01569z",
    className: "st5",
    id: "svg_248"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m884.31214,606.83631l-73.14557,0c-1.64707,0 -2.9961,-1.34903 -2.9961,-2.9961l0,-124.95766c0,-1.64707 1.34903,-2.9961 2.9961,-2.9961l73.14557,0c1.64707,0 2.9961,1.34903 2.9961,2.9961l0,124.95766c-0.01569,1.66276 -1.34903,2.9961 -2.9961,2.9961z",
    className: "st1",
    id: "svg_247"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    fill: "#FFFFFF",
    opacity: 0.2,
    d: "m884.31214,603.69904l-73.14557,0c-1.64707,0 -2.9961,-1.34903 -2.9961,-2.9961l0,-124.95766c0,-1.64707 1.34903,-2.9961 2.9961,-2.9961l73.14557,0c1.64707,0 2.9961,1.34903 2.9961,2.9961l0,124.95766c-0.01569,1.66276 -1.34903,2.9961 -2.9961,2.9961z",
    className: "st2",
    id: "svg_246"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m886.06902,603.69904l-73.11419,0c-1.64707,0 -2.9961,-1.34903 -2.9961,-2.9961l0,-124.95766c0,-1.64707 1.34903,-2.9961 2.9961,-2.9961l73.14557,0c1.64707,0 2.9961,1.34903 2.9961,2.9961l0,124.95766c-0.03137,1.66276 -1.3804,2.98041 -3.02747,2.9961z",
    className: "st1",
    id: "svg_245"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    fill: "#FFFFFF",
    opacity: 0.6,
    d: "m886.06902,603.69904l-73.11419,0c-1.64707,0 -2.9961,-1.34903 -2.9961,-2.9961l0,-124.95766c0,-1.64707 1.34903,-2.9961 2.9961,-2.9961l73.14557,0c1.64707,0 2.9961,1.34903 2.9961,2.9961l0,124.95766c-0.03137,1.66276 -1.3804,2.98041 -3.02747,2.9961z",
    className: "st3",
    id: "svg_244"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m877.1121,597.07939l-20.43935,0c-0.53334,0 -0.97256,-0.42353 -0.97256,-0.95687c0,0 0,-0.01569 0,-0.01569l0,-5.05101c0,-0.53334 0.42353,-0.97256 0.95687,-0.97256c0,0 0.01569,0 0.01569,0l20.43935,0c0.53334,0 0.97256,0.42353 0.97256,0.95687c0,0 0,0.01569 0,0.01569l0,5.05101c0,0.53334 -0.43922,0.95687 -0.97256,0.97256z",
    className: "st4",
    id: "svg_243"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#F3F3F3",
    d: "m871.65324,594.3029l-9.47457,0c-0.39216,0 -0.70589,-0.31373 -0.70589,-0.70589l0,0c0.01569,-0.39216 0.32941,-0.6902 0.70589,-0.70589l9.47457,0c0.39216,0 0.70589,0.31373 0.70589,0.70589l0,0c-0.01569,0.39216 -0.31373,0.6902 -0.70589,0.70589z",
    className: "st0",
    id: "svg_242"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m819.84114,591.46366l0.51765,1.05099c0.03137,0.06275 0.1098,0.1098 0.18824,0.1098l1.12942,0.15686c0.1098,0.01569 0.20392,0.1098 0.18824,0.2353c0,0.06275 -0.03137,0.1098 -0.07843,0.14118l-0.83138,0.78432c-0.04706,0.04706 -0.07843,0.1098 -0.07843,0.18824l0.18824,1.12942c0.03137,0.1098 -0.04706,0.2353 -0.15686,0.26667c-0.06275,0.01569 -0.12549,0 -0.17255,-0.03137l-1.00393,-0.51765c-0.06275,-0.03137 -0.15686,-0.03137 -0.21961,0l-1.00393,0.51765c-0.18824,0.07843 -0.37647,-0.03137 -0.3451,-0.21961l0.18824,-1.12942c0,-0.07843 0,-0.15686 -0.07843,-0.18824l-0.83138,-0.78432c-0.09412,-0.07843 -0.1098,-0.20392 -0.03137,-0.29804c0.03137,-0.04706 0.09412,-0.07843 0.14118,-0.07843l1.12942,-0.15686c0.07843,-0.01569 0.14118,-0.04706 0.18824,-0.1098l0.51765,-1.05099c0.06275,-0.12549 0.20392,-0.17255 0.32941,-0.1098c0.06275,0 0.1098,0.04706 0.12549,0.09412z",
    className: "st1",
    id: "svg_241"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m825.56667,591.46366l0.51765,1.05099c0.03137,0.06275 0.1098,0.1098 0.18824,0.1098l1.12942,0.15686c0.1098,0.01569 0.20392,0.1098 0.18824,0.2353c0,0.06275 -0.03137,0.1098 -0.07843,0.14118l-0.83138,0.78432c-0.04706,0.04706 -0.07843,0.1098 -0.07843,0.18824l0.18824,1.12942c0.03137,0.1098 -0.04706,0.2353 -0.15686,0.26667c-0.06275,0.01569 -0.12549,0 -0.17255,-0.03137l-1.00393,-0.51765c-0.06275,-0.03137 -0.15686,-0.03137 -0.21961,0l-1.00393,0.51765c-0.15686,0.07843 -0.37647,-0.03137 -0.3451,-0.21961l0.18824,-1.12942c0,-0.07843 0,-0.15686 -0.07843,-0.18824l-0.83138,-0.78432c-0.09412,-0.07843 -0.1098,-0.20392 -0.03137,-0.29804c0.03137,-0.04706 0.09412,-0.07843 0.14118,-0.07843l1.12942,-0.15686c0.07843,-0.01569 0.14118,-0.04706 0.18824,-0.1098l0.51765,-1.05099c0.06275,-0.12549 0.20392,-0.17255 0.32941,-0.1098c0.06275,0 0.1098,0.04706 0.12549,0.09412z",
    className: "st1",
    id: "svg_240"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m831.26082,591.46366l0.51765,1.05099c0.03137,0.06275 0.1098,0.1098 0.18824,0.1098l1.12942,0.15686c0.1098,0.01569 0.20392,0.1098 0.18824,0.2353c0,0.06275 -0.03137,0.1098 -0.07843,0.14118l-0.83138,0.78432c-0.04706,0.04706 -0.07843,0.1098 -0.07843,0.18824l0.18824,1.12942c0.03137,0.1098 -0.04706,0.2353 -0.15686,0.26667c-0.06275,0.01569 -0.12549,0 -0.17255,-0.03137l-1.00393,-0.51765c-0.06275,-0.03137 -0.15686,-0.03137 -0.21961,0l-1.00393,0.51765c-0.18824,0.07843 -0.37647,-0.03137 -0.3451,-0.21961l0.18824,-1.12942c0,-0.07843 0,-0.15686 -0.07843,-0.18824l-0.83138,-0.78432c-0.09412,-0.07843 -0.1098,-0.20392 -0.03137,-0.29804c0.03137,-0.04706 0.09412,-0.07843 0.14118,-0.07843l1.12942,-0.15686c0.07843,-0.01569 0.14118,-0.04706 0.18824,-0.1098l0.51765,-1.05099c0.15686,-0.20392 0.37647,-0.20392 0.4549,-0.01569z",
    className: "st1",
    id: "svg_239"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m836.98635,591.46366l0.51765,1.05099c0.03137,0.06275 0.1098,0.1098 0.18824,0.1098l1.12942,0.15686c0.1098,0.01569 0.20392,0.1098 0.18824,0.2353c0,0.06275 -0.03137,0.1098 -0.07843,0.14118l-0.83138,0.78432c-0.04706,0.04706 -0.07843,0.1098 -0.07843,0.18824l0.18824,1.12942c0.03137,0.1098 -0.04706,0.2353 -0.15686,0.26667c-0.06275,0.01569 -0.12549,0 -0.17255,-0.03137l-1.00393,-0.51765c-0.06275,-0.03137 -0.15686,-0.03137 -0.21961,0l-1.00393,0.51765c-0.15686,0.07843 -0.37647,-0.03137 -0.3451,-0.21961l0.18824,-1.12942c0,-0.07843 0,-0.15686 -0.07843,-0.18824l-0.83138,-0.78432c-0.09412,-0.07843 -0.1098,-0.20392 -0.03137,-0.29804c0.03137,-0.04706 0.09412,-0.07843 0.14118,-0.07843l1.12942,-0.15686c0.07843,-0.01569 0.14118,-0.04706 0.18824,-0.1098l0.51765,-1.05099c0.06275,-0.12549 0.20392,-0.17255 0.32941,-0.1098c0.06275,0 0.1098,0.04706 0.12549,0.09412z",
    className: "st1",
    id: "svg_238"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m842.71188,591.46366l0.51765,1.05099c0.03137,0.06275 0.1098,0.1098 0.18824,0.1098l1.12942,0.15686c0.1098,0.01569 0.20392,0.1098 0.18824,0.2353c0,0.06275 -0.03137,0.1098 -0.07843,0.14118l-0.83138,0.78432c-0.04706,0.04706 -0.07843,0.1098 -0.07843,0.18824l0.18824,1.12942c0.03137,0.1098 -0.04706,0.2353 -0.15686,0.26667c-0.06275,0.01569 -0.12549,0 -0.17255,-0.03137l-1.00393,-0.51765c-0.06275,-0.03137 -0.15686,-0.03137 -0.21961,0l-1.00393,0.51765c-0.18824,0.07843 -0.37647,-0.03137 -0.3451,-0.21961l0.18824,-1.12942c0,-0.07843 0,-0.15686 -0.07843,-0.18824l-0.83138,-0.78432c-0.09412,-0.07843 -0.1098,-0.20392 -0.03137,-0.29804c0.03137,-0.04706 0.09412,-0.07843 0.14118,-0.07843l1.12942,-0.15686c0.07843,-0.01569 0.14118,-0.04706 0.18824,-0.1098l0.51765,-1.05099c0.06275,-0.12549 0.20392,-0.17255 0.32941,-0.1098c0.06275,0 0.1098,0.04706 0.12549,0.09412z",
    className: "st1",
    id: "svg_237"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m849.53545,525.64364c12.59616,0 22.7923,-10.21183 22.7923,-22.7923c0,-12.59616 -10.21183,-22.7923 -22.7923,-22.7923c-12.59616,0 -22.7923,10.21183 -22.7923,22.7923c0,12.58047 10.19614,22.7923 22.7923,22.7923z",
    className: "st5",
    id: "svg_236"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m858.58649,493.94147l0,5.64709l-3.13727,0.21961l0.4549,-3.96865l2.68237,-1.89805z",
    className: "st4",
    id: "svg_235"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m849.53545,525.64364c8.42358,0.01569 16.15697,-4.62748 20.10993,-12.04714c-0.26667,-0.07843 -0.54902,-0.14118 -0.83138,-0.18824l-11.34125,-1.49021l-12.98832,-0.32941l-10.03928,1.67844c-1.52158,0.25098 -2.88629,1.06667 -3.81179,2.29021c4.20395,6.30592 11.29419,10.10203 18.90208,10.08634z",
    className: "st4",
    id: "svg_234"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m857.4257,511.91806c0,0.03137 1.2706,0.1098 1.2706,0.18824l0,0.21961c0,2.40002 -3.48238,4.3765 -7.8275,4.3765c-4.29807,0 -7.8275,-1.94511 -7.8275,-4.3765c0,-0.18824 0.03137,-0.37647 0.07843,-0.56471c0,-0.07843 1.23922,-0.15686 1.2706,-0.21961l13.03538,0.37647z",
    className: "st1",
    id: "svg_233"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#966363",
    d: "m844.51581,497.64346c0,0 11.49811,-7.23142 11.93733,1.6157l-0.3451,2.13335l0.94118,10.9334c0.3451,4.18826 -12.61185,4.3765 -12.61185,-0.26667l0.75295,-5.80396c-0.15686,-0.65883 -0.2353,-1.34903 -0.21961,-2.02354c-0.15686,-3.43532 -0.4549,-6.58828 -0.4549,-6.58828z",
    className: "st6",
    id: "svg_232"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m843.46482,497.31404c2.14903,0 3.89022,-1.74119 3.89022,-3.89022s-1.74119,-3.89022 -3.89022,-3.89022s-3.89022,1.74119 -3.89022,3.89022l0,0c0.01569,2.13335 1.75687,3.85885 3.89022,3.89022z",
    className: "st4",
    id: "svg_231"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#966363",
    d: "m843.19815,491.43165c0,0 -4.07846,17.11384 4.7216,18.27463c7.59221,1.00393 8.45496,-10.85497 8.45496,-10.85497l-0.37647,-7.67064l-12.80008,0.25098z",
    className: "st6",
    id: "svg_230"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m854.91588,497.016c0.14118,2.14903 -0.01569,4.29807 -0.48628,6.40004c-0.21961,0.75295 -0.75295,1.45883 -2.24315,0.59608c-5.69415,-3.18433 -9.61575,-0.21961 -9.61575,-0.21961s0.56471,4.67454 4.45493,5.69415c3.70198,1.06667 7.56083,-1.05099 8.62751,-4.75297c0.18824,-0.62745 0.28235,-1.28628 0.28235,-1.94511c0.20392,-2.11766 0.14118,-4.26669 -0.18824,-6.36867c-0.51765,-1.94511 -1.19216,-2.05492 -1.19216,-2.05492l0.36079,2.651z",
    className: "st4",
    id: "svg_229"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m847.27661,484.21592c1.94511,-0.06275 3.7961,0.76863 5.05101,2.24315c0.53334,0.67451 1.39609,0.98824 2.24315,0.81569c0.25098,-0.01569 0.50196,-0.01569 0.75295,0c6.85495,0.48628 5.88239,10.74517 -0.3451,9.91379c-1.42746,-0.25098 -2.61962,-1.23922 -3.13727,-2.58825c-0.43922,-1.00393 -1.56864,-1.53726 -2.61962,-1.23922c-0.62745,0.18824 -1.28628,0.26667 -1.94511,0.26667c-3.29414,0 -5.94514,-2.10197 -5.94514,-4.7216c0.03137,-2.60394 2.69806,-4.69023 5.94514,-4.69023z",
    className: "st4",
    id: "svg_228"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#966363",
    d: "m843.13541,492.82774c0.3451,0.2353 0.70589,0.42353 1.08236,0.59608c0.07843,0.03137 0.17255,0 0.21961,-0.07843c0.04706,-0.09412 0.01569,-0.20392 -0.07843,-0.26667c0,0 -1.00393,-0.59608 -1.12942,-0.67451c-0.29804,-0.21961 -0.54902,-0.47059 -0.78432,-0.75295c-0.06275,-0.07843 -0.17255,-0.09412 -0.26667,-0.03137s-0.09412,0.17255 -0.03137,0.26667c0.29804,0.3451 0.62745,0.65883 0.98824,0.94118z",
    className: "st6",
    id: "svg_227"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m844.65699,510.9455l0.26667,-2.61962c1.34903,1.17648 3.15296,1.66276 4.90984,1.34903c1.19216,-0.12549 2.35296,-0.48628 3.40394,-1.05099c0.07843,-0.06275 0.20392,-0.07843 0.29804,-0.03137c0.07843,0.07843 0.03137,0.15686 -0.03137,0.21961c-1.12942,0.6902 -2.40002,1.11373 -3.70198,1.23922c-1.49021,1.08236 -3.38826,1.41177 -5.14513,0.89412z",
    className: "st7",
    id: "svg_226"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m849.48839,498.96111c0.39216,0 0.70589,-0.31373 0.70589,-0.70589s-0.31373,-0.70589 -0.70589,-0.70589s-0.70589,0.31373 -0.70589,0.70589c0.03137,0.37647 0.32941,0.67451 0.70589,0.70589z",
    className: "st4",
    id: "svg_225"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m849.20604,498.17679c0.09412,0 0.15686,-0.06275 0.15686,-0.15686s-0.06275,-0.15686 -0.15686,-0.15686c-0.09412,0 -0.15686,0.06275 -0.15686,0.15686c0,0 0,0 0,0c0,0.07843 0.06275,0.15686 0.15686,0.15686z",
    className: "st5",
    id: "svg_224"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m843.91973,498.99248c0.39216,0 0.70589,-0.31373 0.70589,-0.70589c0,-0.39216 -0.31373,-0.70589 -0.70589,-0.70589c-0.37647,-0.01569 -0.70589,0.28235 -0.70589,0.65883c0,0.01569 0,0.03137 0,0.04706c0.01569,0.37647 0.31373,0.6902 0.70589,0.70589z",
    className: "st4",
    id: "svg_223"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m843.62169,498.20817c0.09412,0 0.15686,-0.06275 0.15686,-0.15686s-0.06275,-0.15686 -0.15686,-0.15686c-0.09412,0 -0.15686,0.06275 -0.15686,0.15686c0,0 0,0 0,0c0,0.09412 0.06275,0.15686 0.15686,0.15686z",
    className: "st5",
    id: "svg_222"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m840.92363,497.45522l0,0.78432c0,1.53726 1.23922,2.77649 2.7608,2.77649c1.53726,0 2.77649,-1.23922 2.77649,-2.7608c0,0 0,-0.01569 0,-0.01569l0,-0.78432c0.01569,-0.2353 -0.04706,-0.4549 -0.18824,-0.64314l1.08236,0c-0.14118,0.18824 -0.21961,0.40785 -0.21961,0.64314l0,0.78432c0,1.53726 1.23922,2.77649 2.7608,2.77649c1.53726,0 2.77649,-1.23922 2.77649,-2.7608c0,0 0,-0.01569 0,-0.01569l0,-0.78432c0,-0.54902 -0.4549,-1.00393 -1.00393,-1.00393c0,0 0,0 0,0l-9.61575,0c-0.56471,-0.04706 -1.06667,0.37647 -1.11373,0.94118c-0.01569,0.03137 -0.01569,0.04706 -0.01569,0.06275zm7.15299,-0.59608l3.48238,0c0.3451,0.01569 0.62745,0.28235 0.64314,0.64314l0,0.78432c0.01569,1.28628 -1.00393,2.35296 -2.3059,2.38433s-2.35296,-1.00393 -2.38433,-2.3059c0,-0.03137 0,-0.07843 0,-0.1098l0,-0.78432c-0.01569,-0.31373 0.21961,-0.5804 0.51765,-0.59608c0.01569,-0.01569 0.03137,-0.01569 0.04706,-0.01569l0,0zm-6.77651,0.64314c0.01569,-0.3451 0.28235,-0.62745 0.64314,-0.64314l3.48238,0c0.3451,0.01569 0.62745,0.28235 0.64314,0.64314l0,0.78432c-0.04706,1.28628 -1.12942,2.3059 -2.4157,2.25884c-1.23922,-0.04706 -2.24315,-1.05099 -2.25884,-2.3059l-0.09412,-0.73726z",
    className: "st4",
    id: "svg_221"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#966363",
    d: "m855.98255,502.36505l-0.15686,-4.3765c0.32941,-0.95687 1.3804,-1.47452 2.33727,-1.12942c0.04706,0.01569 0.09412,0.03137 0.12549,0.04706c2.10197,0.86275 0.56471,6.40004 -2.3059,5.45886z",
    className: "st6",
    id: "svg_220"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.5,
    className: "st8",
    transform: "translate(336.741 193.457)",
    id: "svg_218"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.5,
    d: "m328.30858,196.35525c0.1098,0 0.21961,-0.1098 0.21961,-0.21961c0,-0.70589 0.15686,-1.16079 0.4549,-1.34903c0.26667,-0.12549 0.5804,-0.14118 0.86275,-0.03137c0.1098,0.04706 0.25098,0 0.29804,-0.1098c0.04706,-0.1098 0,-0.25098 -0.1098,-0.29804l0,0c-0.43922,-0.17255 -0.90981,-0.15686 -1.31766,0.06275c-0.50196,0.42353 -0.76863,1.06667 -0.67451,1.7255c0.03137,0.12549 0.14118,0.20392 0.26667,0.21961z",
    className: "st9",
    id: "svg_219"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m849.15898,504.0435l-3.67061,0l0.1098,0.29804c0.40785,0.95687 1.52158,1.39609 2.47845,0.98824c0.53334,-0.2353 0.94118,-0.70589 1.08236,-1.28628z",
    className: "st5",
    id: "svg_217"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.5,
    className: "st8",
    transform: "translate(329.676 195.152)",
    id: "svg_215"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.5,
    d: "m329.0929,196.35525l0.40785,0c0.12549,0 0.2353,-0.09412 0.2353,-0.21961s-0.1098,-0.2353 -0.2353,-0.2353l-0.40785,0c-0.3451,-0.01569 -0.62745,-0.28235 -0.64314,-0.64314c-0.01569,-0.28235 0.20392,-0.54902 0.48628,-0.5804c0.12549,-0.03137 0.21961,-0.14118 0.18824,-0.26667s-0.12549,-0.20392 -0.25098,-0.18824l0,0c-0.48628,0.12549 -0.83138,0.54902 -0.83138,1.05099c-0.03137,0.56471 0.40785,1.05099 0.97256,1.08236c0.03137,0 0.04706,0 0.07843,0z",
    className: "st9",
    id: "svg_216"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m877.23759,534.74173l-56.00036,0c-0.6902,0.01569 -1.25491,-0.54902 -1.2706,-1.23922c0,-0.01569 0,-0.01569 0,-0.03137l0,-0.94118c-0.01569,-0.6902 0.54902,-1.25491 1.23922,-1.2706c0.01569,0 0.01569,0 0.03137,0l56.00036,0c0.6902,-0.01569 1.25491,0.54902 1.2706,1.23922c0,0.01569 0,0.01569 0,0.03137l0,0.94118c-0.03137,0.6902 -0.5804,1.25491 -1.2706,1.2706z",
    className: "st1",
    id: "svg_214"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#F3F3F3",
    d: "m869.51989,541.78492l-40.61202,0c-0.4549,0 -0.81569,-0.37647 -0.81569,-0.83138c0,-0.4549 0.36079,-0.81569 0.81569,-0.81569l40.61202,0c0.4549,0 0.81569,0.37647 0.83138,0.81569c0.01569,0.43922 -0.3451,0.81569 -0.78432,0.81569c-0.03137,0.01569 -0.03137,0.01569 -0.04706,0.01569z",
    className: "st0",
    id: "svg_213"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.6,
    className: "st10",
    transform: "translate(320.99 228.347)",
    id: "svg_209"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    fill: "#FFFFFF",
    opacity: 0.6,
    d: "m377.01478,195.60231l-48.29835,0c-0.37647,0 -0.67451,-0.29804 -0.67451,-0.67451c0,0 0,0 0,0l0,-0.03137c0,-0.37647 0.29804,-0.67451 0.67451,-0.67451c0,0 0,0 0,0l48.28266,0c0.37647,0 0.67451,0.29804 0.67451,0.67451c0,0 0,0 0,0l0,0.03137c0.01569,0.37647 -0.28235,0.67451 -0.65883,0.67451c0,0 0,0 0,0z",
    className: "st3",
    id: "svg_212"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    fill: "#FFFFFF",
    opacity: 0.6,
    d: "m377.01478,207.74356l-48.29835,0c-0.37647,-0.03137 -0.65883,-0.3451 -0.64314,-0.72157c0.01569,-0.3451 0.29804,-0.62745 0.64314,-0.64314l48.28266,0c0.37647,0 0.67451,0.29804 0.67451,0.67451c0,0 0,0 0,0l0,0.03137c0,0.37647 -0.29804,0.65883 -0.65883,0.65883z",
    className: "st3",
    id: "svg_211"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    fill: "#FFFFFF",
    opacity: 0.6,
    d: "m377.01478,219.9005l-48.29835,0c-0.37647,0 -0.67451,-0.29804 -0.67451,-0.67451c0,0 0,0 0,0l0,-0.03137c0,-0.37647 0.29804,-0.67451 0.67451,-0.67451c0,0 0,0 0,0l48.28266,0c0.37647,0 0.67451,0.29804 0.67451,0.67451c0,0 0,0 0,0l0,0.03137c0.01569,0.37647 -0.28235,0.67451 -0.65883,0.67451c0,0 0,0 0,0z",
    className: "st3",
    id: "svg_210"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    fill: "#FFFFFF",
    opacity: 0.8,
    d: "m823.02548,558.52228l-4.75297,0c-0.47059,0.01569 -0.84706,-0.36079 -0.86275,-0.83138c0,-0.01569 0,-0.01569 0,-0.03137l0,-4.75297c-0.01569,-0.47059 0.36079,-0.84706 0.83138,-0.86275c0.01569,0 0.01569,0 0.03137,0l4.75297,0c0.47059,-0.01569 0.84706,0.36079 0.86275,0.83138c0,0.01569 0,0.01569 0,0.03137l0,4.75297c0.01569,0.47059 -0.36079,0.84706 -0.83138,0.86275c-0.01569,0 -0.01569,0 -0.03137,0z",
    className: "st11",
    id: "svg_208"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m820.18624,556.74972l-1.45883,-1.45883l0.48628,-0.48628l0.97256,0.97256l1.91374,-1.94511l0.48628,0.48628l-2.40002,2.43139z",
    className: "st1",
    id: "svg_207"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    fill: "#FFFFFF",
    opacity: 0.8,
    d: "m823.02548,570.16157l-4.75297,0c-0.47059,0.01569 -0.84706,-0.36079 -0.86275,-0.83138c0,-0.01569 0,-0.01569 0,-0.03137l0,-4.75297c-0.01569,-0.47059 0.36079,-0.84706 0.83138,-0.86275c0.01569,0 0.01569,0 0.03137,0l4.75297,0c0.47059,-0.01569 0.84706,0.36079 0.86275,0.83138c0,0.01569 0,0.01569 0,0.03137l0,4.75297c0.01569,0.47059 -0.36079,0.84706 -0.83138,0.86275c-0.01569,0 -0.01569,0 -0.03137,0z",
    className: "st11",
    id: "svg_206"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m820.18624,568.35763l-1.45883,-1.45883l0.48628,-0.48628l0.97256,0.97256l1.91374,-1.91374l0.48628,0.48628l-2.40002,2.40002z",
    className: "st1",
    id: "svg_205"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    fill: "#FFFFFF",
    opacity: 0.8,
    d: "m823.02548,581.80086l-4.75297,0c-0.47059,0.01569 -0.84706,-0.36079 -0.86275,-0.83138c0,-0.01569 0,-0.01569 0,-0.03137l0,-4.75297c-0.01569,-0.47059 0.36079,-0.84706 0.83138,-0.86275c0.01569,0 0.01569,0 0.03137,0l4.75297,0c0.47059,-0.01569 0.84706,0.36079 0.86275,0.83138c0,0.01569 0,0.01569 0,0.03137l0,4.75297c0,0.47059 -0.39216,0.86275 -0.86275,0.86275z",
    className: "st11",
    id: "svg_204"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m820.18624,579.99692l-1.45883,-1.45883l0.48628,-0.48628l0.97256,0.97256l1.91374,-1.94511l0.48628,0.48628l-2.40002,2.43139z",
    className: "st1",
    id: "svg_203"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.4,
    className: "st12",
    transform: "translate(328.317 164.653)",
    id: "svg_201"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.4,
    d: "m328.04192,194.22191l0.56471,5.80396l1.83531,0l0,-5.80396l-2.40002,0z",
    className: "st13",
    id: "svg_202"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m767.02512,591.38523l1.05099,-46.71402l10.96478,-3.26277l-13.33342,-22.35308c-1.39609,-2.36864 -3.92159,-3.84316 -6.66671,-3.93728l-17.06678,-0.64314l-16.73736,2.72943l0.07843,-1.19216l-17.11384,7.18436c-2.63531,1.09805 -4.34513,3.67061 -4.34513,6.50985l-0.03137,17.41188l15.52951,7.52946l-3.67061,10.4785l0,26.61978l51.34151,-0.36079z",
    className: "st1",
    id: "svg_200"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m769.0016,534.33389c-0.06275,0 -0.14118,-0.03137 -0.18824,-0.07843l-1.67844,-1.56864c-0.1098,-0.1098 -0.1098,-0.26667 0,-0.37647s0.26667,-0.1098 0.37647,0l1.67844,1.56864c0.1098,0.09412 0.1098,0.25098 0.01569,0.36079c0,0 -0.01569,0.01569 -0.01569,0.01569c-0.04706,0.04706 -0.1098,0.07843 -0.18824,0.07843z",
    className: "st5",
    id: "svg_199"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m767.40159,534.38095c-0.06275,0 -0.14118,-0.03137 -0.18824,-0.07843c-0.1098,-0.09412 -0.1098,-0.25098 -0.01569,-0.3451c0,-0.01569 0.01569,-0.01569 0.01569,-0.01569l1.56864,-1.67844c0.1098,-0.1098 0.26667,-0.1098 0.37647,0s0.1098,0.26667 0,0.37647l-1.56864,1.67844c-0.04706,0.03137 -0.12549,0.06275 -0.18824,0.06275z",
    className: "st5",
    id: "svg_198"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m736.73473,588.49894c-0.06275,0 -0.14118,-0.03137 -0.18824,-0.07843l-1.67844,-1.56864c-0.1098,-0.1098 -0.1098,-0.26667 0,-0.37647s0.26667,-0.1098 0.37647,0l1.67844,1.56864c0.1098,0.09412 0.1098,0.25098 0.01569,0.3451c0,0.01569 -0.01569,0.01569 -0.01569,0.01569c-0.04706,0.06275 -0.1098,0.07843 -0.18824,0.09412z",
    className: "st5",
    id: "svg_197"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m735.08766,588.546c-0.06275,0 -0.14118,-0.03137 -0.18824,-0.07843c-0.1098,-0.09412 -0.1098,-0.25098 -0.01569,-0.3451c0,-0.01569 0.01569,-0.01569 0.01569,-0.01569l1.56864,-1.64707c0.1098,-0.1098 0.26667,-0.1098 0.37647,0s0.1098,0.26667 0,0.37647l-1.56864,1.64707c-0.04706,0.03137 -0.1098,0.06275 -0.18824,0.06275z",
    className: "st5",
    id: "svg_196"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m749.87991,525.15736c-0.06275,0 -0.14118,-0.03137 -0.18824,-0.07843l-1.67844,-1.56864c-0.1098,-0.1098 -0.1098,-0.26667 0,-0.37647s0.26667,-0.1098 0.37647,0l0,0l1.67844,1.56864c0.1098,0.09412 0.1098,0.25098 0.01569,0.3451c0,0.01569 -0.01569,0.01569 -0.01569,0.01569c-0.06275,0.06275 -0.12549,0.07843 -0.18824,0.09412z",
    className: "st5",
    id: "svg_195"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m748.23284,525.20442c-0.06275,0 -0.14118,-0.03137 -0.18824,-0.07843c-0.1098,-0.09412 -0.1098,-0.25098 -0.01569,-0.3451c0,-0.01569 0.01569,-0.01569 0.01569,-0.01569l1.56864,-1.67844c0.1098,-0.1098 0.26667,-0.1098 0.37647,0s0.1098,0.26667 0,0.37647l0,0l-1.56864,1.67844c-0.04706,0.06275 -0.1098,0.06275 -0.18824,0.06275z",
    className: "st5",
    id: "svg_194"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m732.89157,534.36526c-1.11373,0 -2.02354,-0.90981 -2.02354,-2.02354s0.90981,-2.02354 2.02354,-2.02354s2.02354,0.90981 2.02354,2.02354c-0.01569,1.11373 -0.9255,2.02354 -2.02354,2.02354zm0,-3.48238c-0.80001,-0.03137 -1.47452,0.61177 -1.50589,1.41177s0.61177,1.47452 1.41177,1.50589c0.03137,0 0.06275,0 0.09412,0c0.80001,0.03137 1.47452,-0.61177 1.50589,-1.41177s-0.61177,-1.47452 -1.41177,-1.50589c-0.03137,0 -0.06275,0 -0.09412,0z",
    className: "st5",
    id: "svg_193"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m761.11135,576.89102c-0.14118,0 -0.25098,-0.1098 -0.26667,-0.25098c0,0 0,-0.01569 0,-0.01569c0.03137,-0.80001 -0.61177,-1.47452 -1.41177,-1.50589s-1.47452,0.61177 -1.50589,1.41177c0,0.03137 0,0.06275 0,0.09412c0,0.14118 -0.1098,0.26667 -0.26667,0.26667c-0.14118,0 -0.26667,-0.1098 -0.26667,-0.26667c-0.03137,-1.11373 0.84706,-2.03923 1.9608,-2.0706c1.11373,-0.03137 2.03923,0.84706 2.0706,1.9608c0,0.03137 0,0.07843 0,0.1098c-0.01569,0.15686 -0.15686,0.26667 -0.31373,0.26667z",
    className: "st5",
    id: "svg_192"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m714.61694,537.00057c-0.14118,0 -0.25098,-0.1098 -0.26667,-0.25098c0,0 0,-0.01569 0,-0.01569c0,-0.80001 -0.65883,-1.45883 -1.45883,-1.45883c-0.80001,0.01569 -1.44315,0.65883 -1.45883,1.45883c0,0.14118 -0.1098,0.26667 -0.26667,0.26667c-0.14118,0 -0.26667,-0.1098 -0.26667,-0.26667c0,-1.09805 0.89412,-1.99217 1.97648,-1.99217s1.99217,0.89412 1.99217,1.97648c0,0 0,0 0,0c0.01569,0.15686 -0.09412,0.26667 -0.25098,0.28235c0,0 0,0 0,0z",
    className: "st5",
    id: "svg_191"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m718.61696,587.98129c-1.11373,0 -2.02354,-0.90981 -2.02354,-2.02354s0.90981,-2.02354 2.02354,-2.02354s2.02354,0.90981 2.02354,2.02354c0,1.11373 -0.90981,2.00786 -2.02354,2.02354zm0,-3.451c-0.80001,0 -1.45883,0.65883 -1.45883,1.45883c0,0.80001 0.65883,1.45883 1.45883,1.45883c0.80001,0 1.45883,-0.65883 1.45883,-1.45883c0,-0.80001 -0.65883,-1.45883 -1.45883,-1.45883l0,0z",
    className: "st5",
    id: "svg_190"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m712.02869,528.07502l-3.70198,-1.2706c-0.14118,-0.04706 -0.21961,-0.18824 -0.18824,-0.3451s0.18824,-0.21961 0.3451,-0.18824l3.70198,1.23922c0.15686,0.04706 0.2353,0.21961 0.18824,0.36079c-0.04706,0.15686 -0.18824,0.25098 -0.3451,0.20392l0,0z",
    className: "st5",
    id: "svg_189"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m747.63676,532.60839l-3.89022,0c-0.14118,0 -0.26667,-0.1098 -0.26667,-0.26667c0,-0.14118 0.1098,-0.26667 0.26667,-0.26667l0,0l3.89022,0c0.14118,0 0.25098,0.1098 0.26667,0.25098c0,0 0,0.01569 0,0.01569c0.03137,0.15686 -0.07843,0.26667 -0.26667,0.26667z",
    className: "st5",
    id: "svg_188"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m756.20152,520.10634c-0.06275,0 -0.14118,-0.03137 -0.18824,-0.07843c-0.1098,-0.09412 -0.1098,-0.25098 -0.01569,-0.3451c0,-0.01569 0.01569,-0.01569 0.01569,-0.01569l2.77649,-2.77649c0.1098,-0.1098 0.26667,-0.1098 0.37647,0s0.1098,0.26667 0,0.37647l-2.77649,2.77649c-0.04706,0.03137 -0.12549,0.04706 -0.18824,0.06275z",
    className: "st5",
    id: "svg_187"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m735.35433,535.60448c-0.98824,0 -1.80393,-0.80001 -1.80393,-1.78825s0.80001,-1.80393 1.78825,-1.80393c0.98824,0 1.80393,0.80001 1.80393,1.78825c0,0 0,0 0,0c0,1.00393 -0.80001,1.80393 -1.78825,1.80393zm0,-3.48238c-0.9255,0 -1.67844,0.75295 -1.67844,1.67844s0.75295,1.67844 1.67844,1.67844c0.9255,0 1.67844,-0.75295 1.67844,-1.67844c0,-0.9255 -0.73726,-1.67844 -1.66276,-1.67844c0,0 -0.01569,0 -0.01569,0z",
    className: "st5",
    id: "svg_186"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m763.65255,578.09887l-0.1098,0c0,-0.9255 -0.75295,-1.67844 -1.67844,-1.67844s-1.67844,0.75295 -1.67844,1.67844l-0.1098,0c0,-0.98824 0.80001,-1.80393 1.78825,-1.80393c0.97256,-0.01569 1.78825,0.76863 1.80393,1.75687c-0.01569,0.01569 -0.01569,0.03137 -0.01569,0.04706z",
    className: "st5",
    id: "svg_185"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m717.15813,538.19274l-0.1098,0c0,-0.9255 -0.75295,-1.67844 -1.67844,-1.67844s-1.67844,0.75295 -1.67844,1.67844l-0.1098,0c0,-0.98824 0.80001,-1.80393 1.80393,-1.80393c0.97256,-0.01569 1.78825,0.76863 1.78825,1.75687c-0.01569,0.01569 -0.01569,0.03137 -0.01569,0.04706z",
    className: "st5",
    id: "svg_184"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m721.09541,589.22051c-0.98824,0 -1.80393,-0.80001 -1.80393,-1.80393s0.80001,-1.80393 1.80393,-1.80393c0.98824,0 1.80393,0.80001 1.80393,1.80393l0,0c-0.01569,0.98824 -0.81569,1.80393 -1.80393,1.80393zm0,-3.451c-0.9255,0 -1.67844,0.75295 -1.67844,1.67844c0,0.9255 0.75295,1.67844 1.67844,1.67844c0.9255,0 1.67844,-0.75295 1.67844,-1.67844l0,0c0,-0.9255 -0.75295,-1.67844 -1.67844,-1.67844l0,0z",
    className: "st5",
    id: "svg_183"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m753.09562,585.36166c-1.11373,0 -2.02354,-0.90981 -2.02354,-2.02354s0.90981,-2.02354 2.02354,-2.02354s2.02354,0.90981 2.02354,2.02354c0,1.11373 -0.89412,2.02354 -2.00786,2.02354c0,0 0,0 -0.01569,0zm0,-3.451c-0.80001,0.01569 -1.44315,0.65883 -1.45883,1.45883c-0.03137,0.80001 0.61177,1.47452 1.41177,1.50589s1.47452,-0.61177 1.50589,-1.41177c0,-0.03137 0,-0.06275 0,-0.09412c0.01569,-0.80001 -0.62745,-1.44315 -1.42746,-1.45883c0,0 -0.01569,0 -0.03137,0l0,0z",
    className: "st5",
    id: "svg_182"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m755.57406,586.60089c-0.98824,0 -1.80393,-0.80001 -1.80393,-1.78825c0,-0.98824 0.80001,-1.80393 1.78825,-1.80393c0.98824,0 1.80393,0.80001 1.80393,1.78825c0,0 0,0 0,0c0.01569,0.97256 -0.76863,1.78825 -1.75687,1.80393c0,0 -0.01569,0 -0.03137,0zm0,-3.451c-0.9255,0 -1.67844,0.75295 -1.67844,1.67844c0,0.9255 0.75295,1.67844 1.67844,1.67844c0.9255,0 1.67844,-0.75295 1.67844,-1.67844l0,0c0.01569,-0.90981 -0.72157,-1.66276 -1.63138,-1.67844c-0.01569,0 -0.03137,0 -0.04706,0l0,0z",
    className: "st5",
    id: "svg_181"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m710.30319,528.68679l-0.03137,0.1098l3.70198,1.23922l0.03137,-0.1098l-3.70198,-1.23922z",
    className: "st5",
    id: "svg_180"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m750.14658,533.7378l-3.93728,0l0,0.1098l3.93728,0l0,-0.1098z",
    className: "st5",
    id: "svg_179"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m761.40939,518.50633l-2.77649,2.77649l0.07843,0.07843l2.77649,-2.77649l-0.07843,-0.07843z",
    className: "st5",
    id: "svg_178"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m764.43687,560.54582c-0.07843,0 -0.15686,0 -0.21961,-0.03137c-0.25098,-0.06275 -0.4549,-0.20392 -0.59608,-0.40785c-0.14118,-0.20392 -0.18824,-0.47059 -0.1098,-0.70589c0.06275,-0.25098 0.20392,-0.4549 0.40785,-0.59608c0.20392,-0.14118 0.47059,-0.18824 0.70589,-0.1098c0.25098,0.04706 0.47059,0.18824 0.59608,0.40785c0.14118,0.20392 0.18824,0.47059 0.1098,0.70589c-0.04706,0.25098 -0.20392,0.4549 -0.40785,0.59608c-0.14118,0.07843 -0.31373,0.14118 -0.48628,0.14118zm0,-1.34903c-0.07843,0.01569 -0.15686,0.03137 -0.21961,0.07843c-0.07843,0.07843 -0.14118,0.15686 -0.18824,0.26667c-0.03137,0.09412 -0.01569,0.20392 0.03137,0.29804c0.07843,0.07843 0.15686,0.14118 0.26667,0.18824c0.09412,0.03137 0.20392,0.01569 0.29804,-0.03137c0.07843,-0.07843 0.14118,-0.15686 0.18824,-0.26667c0.03137,-0.09412 0.01569,-0.20392 -0.03137,-0.29804c-0.07843,-0.07843 -0.15686,-0.14118 -0.26667,-0.18824c-0.01569,-0.03137 -0.04706,-0.04706 -0.07843,-0.04706z",
    className: "st5",
    id: "svg_177"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m763.87216,588.76561c-0.07843,0 -0.15686,0 -0.21961,-0.03137c-0.25098,-0.04706 -0.4549,-0.20392 -0.59608,-0.40785c-0.28235,-0.42353 -0.17255,-1.00393 0.25098,-1.28628c0.01569,-0.01569 0.03137,-0.01569 0.04706,-0.03137c0.20392,-0.14118 0.47059,-0.18824 0.70589,-0.1098c0.25098,0.04706 0.47059,0.18824 0.59608,0.40785c0.14118,0.20392 0.18824,0.47059 0.1098,0.70589c-0.06275,0.2353 -0.21961,0.4549 -0.40785,0.59608c-0.14118,0.09412 -0.31373,0.15686 -0.48628,0.15686zm0,-1.3804c-0.07843,0.01569 -0.15686,0.03137 -0.21961,0.07843c-0.18824,0.1098 -0.25098,0.3451 -0.14118,0.51765c0.01569,0.01569 0.01569,0.03137 0.03137,0.04706c0.07843,0.07843 0.15686,0.14118 0.26667,0.18824c0.09412,0.03137 0.20392,0.01569 0.29804,-0.03137c0.07843,-0.07843 0.14118,-0.15686 0.18824,-0.26667c0.03137,-0.09412 0.01569,-0.20392 -0.03137,-0.29804c-0.07843,-0.07843 -0.15686,-0.14118 -0.26667,-0.18824c-0.03137,-0.04706 -0.07843,-0.06275 -0.12549,-0.04706z",
    className: "st5",
    id: "svg_176"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m719.58952,525.53383c-0.07843,0 -0.15686,0 -0.21961,-0.03137c-0.25098,-0.04706 -0.47059,-0.18824 -0.59608,-0.40785c-0.14118,-0.20392 -0.18824,-0.47059 -0.1098,-0.70589c0.04706,-0.25098 0.18824,-0.47059 0.40785,-0.59608c0.20392,-0.14118 0.47059,-0.18824 0.70589,-0.1098c0.25098,0.04706 0.47059,0.18824 0.59608,0.40785c0.14118,0.20392 0.18824,0.47059 0.1098,0.70589c-0.04706,0.25098 -0.18824,0.47059 -0.40785,0.59608c-0.12549,0.1098 -0.31373,0.15686 -0.48628,0.14118zm0,-1.34903c-0.07843,0.01569 -0.15686,0.03137 -0.21961,0.07843c-0.07843,0.07843 -0.14118,0.15686 -0.18824,0.26667c-0.03137,0.09412 -0.01569,0.20392 0.03137,0.29804c0.07843,0.07843 0.15686,0.14118 0.26667,0.18824c0.09412,0.03137 0.20392,0.01569 0.29804,-0.03137c0.09412,-0.06275 0.15686,-0.15686 0.18824,-0.26667c0.03137,-0.09412 0.01569,-0.20392 -0.03137,-0.29804c-0.07843,-0.07843 -0.15686,-0.14118 -0.26667,-0.18824c0,-0.04706 -0.03137,-0.04706 -0.07843,-0.04706z",
    className: "st5",
    id: "svg_175"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m762.11528,527.71424c-0.32941,0 -0.64314,-0.15686 -0.81569,-0.4549c-0.14118,-0.20392 -0.18824,-0.47059 -0.1098,-0.70589c0.06275,-0.25098 0.20392,-0.4549 0.40785,-0.59608c0.20392,-0.14118 0.47059,-0.18824 0.70589,-0.1098c0.25098,0.04706 0.47059,0.18824 0.59608,0.40785c0.14118,0.20392 0.18824,0.47059 0.1098,0.70589c-0.04706,0.25098 -0.18824,0.47059 -0.40785,0.59608c-0.14118,0.09412 -0.31373,0.14118 -0.48628,0.15686zm0,-1.39609c-0.07843,0.01569 -0.15686,0.03137 -0.21961,0.07843c-0.07843,0.07843 -0.14118,0.15686 -0.18824,0.26667c-0.03137,0.09412 -0.01569,0.20392 0.03137,0.29804c0.1098,0.18824 0.36079,0.26667 0.56471,0.15686c0.07843,-0.07843 0.14118,-0.15686 0.18824,-0.26667c0.03137,-0.09412 0.01569,-0.20392 -0.03137,-0.29804c-0.07843,-0.07843 -0.15686,-0.14118 -0.26667,-0.18824c0,-0.04706 -0.03137,-0.04706 -0.07843,-0.04706z",
    className: "st5",
    id: "svg_174"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FA9B9B",
    d: "m759.76233,753.84902l24.00015,0.59608l-9.58438,-6.85495c-1.58432,-1.16079 -2.57257,-2.98041 -2.651,-4.94121l-0.32941,-7.52946l-13.06675,0.07843l1.63138,18.6511z",
    className: "st14",
    id: "svg_173"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m762.41332,745.09602l0,-0.15686c-0.07843,-0.83138 0.51765,-1.58432 1.34903,-1.67844l7.67064,-1.12942l-0.07843,-1.53726l-12.80008,0l1.16079,12.72165l10.4785,-1.16079l-3.451,-1.3804c-2.4157,-0.89412 -4.09414,-3.1059 -4.32944,-5.67847z",
    className: "st7",
    id: "svg_172"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FA9B9B",
    d: "m716.48362,753.4098l10.8236,0l1.99217,-18.27463l-12.76871,0.03137l-0.04706,18.24325z",
    className: "st14",
    id: "svg_171"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m719.18167,750.33527l0.26667,-5.61572c0.04706,-0.75295 0.61177,-1.36471 1.34903,-1.45883l7.78044,-1.19216l0.18824,-1.56864l-12.17263,0.03137l-0.03137,12.95695l2.61962,-3.15296z",
    className: "st7",
    id: "svg_170"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m715.77773,591.16562l0,149.44409l14.03931,0l12.204,-121.85176c0.07843,-0.86275 0.83138,-1.49021 1.67844,-1.42746c0.75295,0.06275 1.36471,0.65883 1.42746,1.42746l12.98832,121.85176l14.03931,0l-5.05101,-149.44409l-51.32582,0z",
    className: "st1",
    id: "svg_169"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#3F4249",
    d: "m715.77773,591.16562l0,149.44409l14.03931,0l12.204,-121.85176c0.07843,-0.86275 0.83138,-1.49021 1.67844,-1.42746c0.75295,0.06275 1.36471,0.65883 1.42746,1.42746l12.98832,121.85176l14.03931,0l-5.05101,-149.44409l-51.32582,0z",
    className: "st15",
    id: "svg_168"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#3F4249",
    d: "m717.31499,746.9627l0.32941,-0.3451c2.60394,-2.50982 6.74514,-2.46276 9.28633,0.1098l0.18824,0.21961c0.61177,0.62745 0.95687,1.47452 0.97256,2.35296l0,1.42746c0,0.81569 0.12549,1.6157 0.37647,2.40002l1.16079,3.81179c0.29804,0.9255 0.4549,1.88236 0.4549,2.83923l0,0.48628c-0.03137,0.76863 -0.6902,1.3804 -1.45883,1.34903l-13.28636,0c-0.76863,0.03137 -1.42746,-0.54902 -1.45883,-1.31766c0,-0.01569 0,-0.01569 0,-0.03137l0,-0.18824c0,-1.12942 0.18824,-2.24315 0.56471,-3.29414l1.34903,-3.74904c0.31373,-0.84706 0.47059,-1.75687 0.48628,-2.651l0.03137,-1.08236c0.01569,-0.86275 0.39216,-1.70981 1.00393,-2.33727z",
    className: "st15",
    id: "svg_167"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m715.40126,740.59403l14.93343,0l0.29804,-3.07453l-15.2001,0l-0.03137,3.07453z",
    className: "st1",
    id: "svg_166"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m715.40126,740.59403l6.24318,0l0.15686,-3.07453l-6.36867,0l-0.03137,3.07453z",
    className: "st7",
    id: "svg_165"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.5,
    d: "m713.86399,760.10788l0,0.18824c0.03137,0.76863 0.6902,1.3804 1.45883,1.34903l13.28636,0c0.76863,0.03137 1.42746,-0.54902 1.45883,-1.31766c0,-0.01569 0,-0.01569 0,-0.03137l0,-0.48628c0,-0.18824 0,-0.37647 -0.03137,-0.56471l-16.12559,0c-0.04706,0.28235 -0.04706,0.56471 -0.04706,0.86275z",
    className: "st9",
    id: "svg_164"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#3F4249",
    d: "m758.08388,749.58232l0,9.36477c0,1.50589 1.20785,2.72943 2.71374,2.72943c0,0 0.01569,0 0.01569,0l31.82765,0c0.64314,0 1.16079,-0.51765 1.16079,-1.16079c-0.01569,-2.22747 -1.44315,-4.20395 -3.56081,-4.90984l-7.18436,-2.35296l-9.0981,-7.07456c-0.94118,-0.73726 -2.27452,-0.70589 -3.18433,0.07843l-4.04708,3.451c-0.5804,0.50196 -1.39609,0.67451 -2.13335,0.4549l-5.09807,-1.56864c-0.5804,-0.17255 -1.19216,0.14118 -1.3804,0.72157c-0.01569,0.07843 -0.03137,0.17255 -0.03137,0.26667z",
    className: "st15",
    id: "svg_163"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "m760.81331,761.70789l31.81197,0c0.64314,0 1.16079,-0.51765 1.16079,-1.16079c0,-0.39216 -0.04706,-0.78432 -0.15686,-1.16079l-35.51395,0c0.21961,1.33334 1.34903,2.3059 2.69806,2.32158z",
    id: "svg_162"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m773.75457,749.92742c-0.06275,0 -0.14118,-0.03137 -0.18824,-0.07843c-0.1098,-0.1098 -0.1098,-0.29804 0,-0.40785l1.91374,-2.05492c0.1098,-0.1098 0.29804,-0.1098 0.40785,0.01569c0.1098,0.1098 0.1098,0.28235 0,0.40785l-1.91374,2.05492c-0.06275,0.03137 -0.12549,0.04706 -0.21961,0.06275z",
    className: "st5",
    id: "svg_161"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m775.29184,751.11959c-0.06275,0 -0.14118,-0.03137 -0.18824,-0.07843c-0.1098,-0.1098 -0.1098,-0.29804 0,-0.40785l1.91374,-2.05492c0.1098,-0.12549 0.29804,-0.12549 0.40785,-0.03137c0.12549,0.1098 0.12549,0.29804 0.03137,0.40785c-0.01569,0.01569 -0.01569,0.01569 -0.03137,0.03137l-1.91374,2.05492c-0.06275,0.04706 -0.14118,0.07843 -0.21961,0.07843z",
    className: "st5",
    id: "svg_160"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m776.79773,752.31175c-0.06275,0 -0.14118,-0.03137 -0.18824,-0.07843c-0.1098,-0.1098 -0.1098,-0.29804 0,-0.40785l1.91374,-2.05492c0.1098,-0.1098 0.29804,-0.1098 0.40785,0.01569c0.1098,0.1098 0.1098,0.28235 0,0.40785l-1.91374,2.05492c-0.06275,0.04706 -0.14118,0.07843 -0.21961,0.06275z",
    className: "st5",
    id: "svg_159"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m724.68759,750.11566c-0.06275,0 -0.1098,0 -0.15686,-0.03137c-1.53726,-0.73726 -3.32551,-0.73726 -4.86278,0c-0.17255,0.07843 -0.36079,0.01569 -0.4549,-0.15686c-0.07843,-0.17255 -0.01569,-0.36079 0.15686,-0.4549c1.7255,-0.86275 3.76473,-0.86275 5.50592,0c0.15686,0.09412 0.21961,0.28235 0.15686,0.4549c-0.07843,0.1098 -0.20392,0.18824 -0.3451,0.18824z",
    className: "st5",
    id: "svg_158"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m724.68759,751.82547c-0.06275,0 -0.1098,0 -0.15686,-0.03137c-1.53726,-0.73726 -3.32551,-0.73726 -4.86278,0c-0.17255,0.07843 -0.36079,0.01569 -0.4549,-0.15686c-0.07843,-0.17255 -0.01569,-0.36079 0.15686,-0.4549c1.7255,-0.86275 3.76473,-0.86275 5.50592,0c0.15686,0.09412 0.21961,0.28235 0.15686,0.4549c-0.07843,0.12549 -0.20392,0.18824 -0.3451,0.18824z",
    className: "st5",
    id: "svg_157"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m724.68759,753.47254c-0.06275,0 -0.1098,0 -0.15686,-0.03137c-1.53726,-0.73726 -3.32551,-0.73726 -4.86278,0c-0.17255,0.07843 -0.36079,-0.01569 -0.43922,-0.17255c-0.06275,-0.15686 0,-0.32941 0.14118,-0.42353c1.7255,-0.86275 3.76473,-0.86275 5.50592,0c0.15686,0.09412 0.21961,0.28235 0.15686,0.4549c-0.07843,0.1098 -0.20392,0.17255 -0.3451,0.17255z",
    className: "st5",
    id: "svg_156"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.2,
    d: "m766.42903,738.91559l-13.85107,-115.04387c-0.43922,-3.6863 -3.57649,-6.46279 -7.29416,-6.47847l-1.7255,0c0.80001,0 1.47452,0.62745 1.53726,1.42746l12.90989,121.17725l8.42358,-1.08236z",
    className: "st16",
    id: "svg_155"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m757.70741,740.59403l14.90206,0l-0.21961,-3.07453l-14.98049,0l0.29804,3.07453z",
    className: "st1",
    id: "svg_154"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m757.70741,740.59403l8.87849,0l-0.32941,-3.07453l-8.83143,0l0.28235,3.07453z",
    className: "st7",
    id: "svg_153"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.15,
    className: "st17",
    transform: "translate(257.033 255.028)",
    id: "svg_151"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.4,
    d: "m359.79114,194.81799l-31.45118,0c-0.15686,0 -0.29804,-0.12549 -0.29804,-0.28235c0,0 0,0 0,-0.01569c0.01569,-0.15686 0.14118,-0.28235 0.29804,-0.29804l31.45118,0c0.17255,0 0.29804,0.14118 0.29804,0.29804c0,0.17255 -0.14118,0.29804 -0.29804,0.29804l0,0l0,0z",
    className: "st13",
    id: "svg_152"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.2,
    d: "m715.77773,591.46366l0,145.99309l6.02357,0.03137l1.2706,-146.04015l-7.29416,0.01569z",
    className: "st16",
    id: "svg_150"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FA9B9B",
    d: "m742.20927,497.09443c0,0 -15.09029,-9.47457 -15.68637,2.10197l-0.21961,2.9961l-1.00393,15.01186l0,0.18824c0,0.42353 0.14118,0.83138 0.40785,1.16079l8.72162,5.94514c0.26667,0.17255 0.61177,0.15686 0.86275,-0.03137l6.47847,-5.50592c0.43922,-0.37647 0.67451,-0.95687 0.59608,-1.53726l-0.21961,-2.21178l-0.70589,-6.77651c0.20392,-0.87844 0.29804,-1.75687 0.29804,-2.651c0.04706,-4.58042 0.47059,-8.69025 0.47059,-8.69025z",
    className: "st14",
    id: "svg_149"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m743.5583,497.80032c2.80786,0 5.09807,-2.27452 5.09807,-5.09807s-2.27452,-5.09807 -5.09807,-5.09807s-5.09807,2.27452 -5.09807,5.09807c0,2.82355 2.27452,5.09807 5.09807,5.09807z",
    className: "st4",
    id: "svg_148"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FA9B9B",
    d: "m743.91909,488.89046c0,0 5.34905,22.49426 -6.18043,24.03153c-9.99222,1.34903 -11.07458,-14.25891 -11.07458,-14.25891l0.48628,-10.10203l16.76873,0.32941z",
    className: "st14",
    id: "svg_147"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m743.26026,490.31792l-10.22752,0.75295c-1.25491,0.1098 -2.19609,1.20785 -2.13335,2.47845c0.09412,1.2706 -0.86275,2.36864 -2.13335,2.46276c0,0 0,0 0,0c-0.3451,0.04706 -0.59608,0.32941 -0.59608,0.67451l0.15686,2.24315c0.03137,0.26667 -0.15686,0.51765 -0.42353,0.54902c-0.01569,0 -0.04706,0 -0.06275,0c-0.26667,0.03137 -0.50196,-0.15686 -0.56471,-0.40785l-0.4549,-2.13335l-0.4549,-0.70589l-2.40002,1.49021c0,0 -3.89022,-5.9922 -2.02354,-11.45105c0.94118,-2.38433 3.07453,-4.07846 5.61572,-4.42356c0.47059,-0.06275 0.90981,-0.3451 1.16079,-0.75295c1.08236,-1.81962 3.13727,-2.85492 5.23925,-2.61962c1.85099,0.01569 3.56081,0.95687 4.56474,2.50982c0.42353,0.64314 1.25491,0.87844 1.94511,0.56471c1.41177,-0.65883 3.05884,-0.53334 4.34513,0.32941c3.30983,2.11766 1.99217,7.87456 -1.55295,8.43927z",
    className: "st4",
    id: "svg_146"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m726.30329,502.92976c0.51765,0.04706 1.05099,-0.07843 1.49021,-0.32941l-1.64707,2.50982l0.15686,-2.18041z",
    className: "st7",
    id: "svg_145"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FA9B9B",
    d: "m726.85231,496.93757c-0.37647,-1.09805 -1.56864,-1.66276 -2.66668,-1.28628c-0.09412,0.03137 -0.20392,0.07843 -0.29804,0.12549c-2.50982,1.12942 -1.99217,6.80789 2.24315,7.15299c2.21178,0.18824 1.78825,-1.12942 1.42746,-2.83923l-0.70589,-3.15296z",
    className: "st14",
    id: "svg_144"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.3,
    d: "m723.79347,497.26698c0.3451,-0.26667 0.80001,-0.39216 1.23922,-0.32941c0.42353,0.1098 0.78432,0.39216 0.97256,0.78432c0.26667,0.47059 0.40785,0.98824 0.40785,1.53726l0.03137,0.48628c0,0.14118 -0.1098,0.26667 -0.26667,0.26667c-0.14118,0 -0.26667,-0.1098 -0.26667,-0.26667l-0.03137,-0.48628c-0.01569,-0.4549 -0.12549,-0.90981 -0.32941,-1.30197c-0.17255,-0.47059 -0.6902,-0.70589 -1.16079,-0.53334c-0.1098,0.04706 -0.21961,0.1098 -0.31373,0.18824c-0.12549,0.07843 -0.28235,0.04706 -0.37647,-0.07843c-0.06275,0 -0.01569,-0.14118 0.09412,-0.26667z",
    className: "st18",
    id: "svg_143"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FA9B9B",
    d: "m743.323,490.8042l-1.19216,0.1098c-0.14118,0.01569 -0.25098,-0.09412 -0.26667,-0.21961c0,-0.15686 0.07843,-0.26667 0.21961,-0.26667l1.19216,-0.1098c0.15686,0 0.29804,-0.03137 0.4549,-0.07843c0.48628,-0.15686 0.95687,-0.39216 1.3804,-0.67451c0.1098,-0.07843 0.26667,-0.06275 0.3451,0.04706s0.06275,0.26667 -0.04706,0.3451c-0.01569,0.01569 -0.03137,0.01569 -0.03137,0.03137c-0.4549,0.31373 -0.97256,0.54902 -1.49021,0.70589l-0.56471,0.1098z",
    className: "st14",
    id: "svg_142"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m742.05241,514.75729l-0.37647,-3.59218c-1.86668,1.63138 -4.40787,2.24315 -6.80789,1.64707l0,0c-1.58432,-0.39216 -2.9961,-1.2706 -4.04708,-2.50982c-0.07843,-0.1098 -0.2353,-0.12549 -0.32941,-0.04706s-0.12549,0.2353 -0.04706,0.32941c0,0 0,0 0,0c3.38826,2.49413 7.41966,3.92159 11.60792,4.17258l0,0z",
    className: "st7",
    id: "svg_141"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.3,
    className: "st19",
    transform: "translate(260.589 199.829)",
    id: "svg_139"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.3,
    d: "m329.79879,194.86505c0,0.03137 -0.03137,0.03137 0,0c-0.97256,0.06275 -1.41177,0.1098 -1.41177,0.1098c-0.17255,0 -0.32941,-0.12549 -0.3451,-0.29804c-0.01569,-0.17255 0.1098,-0.32941 0.28235,-0.32941c0,0 0,0 0.01569,0l1.39609,-0.12549c0.17255,-0.01569 0.31373,0.09412 0.32941,0.26667c0,0.21961 -0.1098,0.37647 -0.26667,0.37647z",
    className: "st18",
    id: "svg_140"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.3,
    className: "st19",
    transform: "translate(259.42 198.04)",
    id: "svg_137"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.3,
    d: "m332.16743,196.35525c-1.58432,0.36079 -3.21571,-0.31373 -4.07846,-1.67844c-0.09412,-0.15686 -0.03137,-0.32941 0.1098,-0.42353s0.32941,-0.03137 0.40785,0.1098l0,0c0.37647,0.67451 1.6157,2.10197 4.64317,1.12942c0.15686,-0.04706 0.31373,0.04706 0.36079,0.20392c0.03137,0.14118 -0.03137,0.29804 -0.17255,0.3451c-0.40785,0.15686 -0.84706,0.26667 -1.2706,0.31373z",
    className: "st18",
    id: "svg_138"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m735.62099,500.34151c0.51765,0 0.94118,-0.42353 0.94118,-0.94118c0,-0.51765 -0.42353,-0.94118 -0.94118,-0.94118c-0.51765,0 -0.94118,0.42353 -0.94118,0.94118c0.01569,0.51765 0.42353,0.9255 0.94118,0.94118z",
    className: "st4",
    id: "svg_136"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m736.02884,499.29053c0.1098,0 0.18824,-0.07843 0.18824,-0.18824s-0.07843,-0.18824 -0.18824,-0.18824c-0.1098,0 -0.18824,0.07843 -0.18824,0.18824l0,0c0,0.09412 0.06275,0.18824 0.17255,0.18824c0,0 0.01569,0 0.01569,0z",
    className: "st5",
    id: "svg_135"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m742.96222,500.38857c0.51765,0 0.94118,-0.42353 0.94118,-0.94118c0,-0.51765 -0.42353,-0.94118 -0.94118,-0.94118c-0.51765,0 -0.94118,0.42353 -0.94118,0.94118c-0.01569,0.51765 0.40785,0.94118 0.90981,0.94118c0.01569,0 0.01569,0 0.03137,0z",
    className: "st4",
    id: "svg_134"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m743.37006,499.33758c0.1098,0 0.18824,-0.07843 0.18824,-0.18824s-0.07843,-0.18824 -0.18824,-0.18824c-0.1098,0 -0.18824,0.07843 -0.18824,0.18824l0,0c0,0.09412 0.06275,0.18824 0.17255,0.18824c0,0 0,0 0.01569,0z",
    className: "st5",
    id: "svg_133"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.3,
    className: "st19",
    transform: "translate(261.496 196.535)",
    id: "svg_131"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.3,
    d: "m329.57918,196.46506l-1.23922,0.07843c-0.15686,0.01569 -0.28235,-0.1098 -0.29804,-0.26667c-0.01569,-0.15686 0.1098,-0.28235 0.26667,-0.29804l1.23922,-0.07843c0.31373,-0.03137 0.53334,-0.31373 0.50196,-0.61177c-0.03137,-0.29804 -0.28235,-0.51765 -0.5804,-0.50196c-0.15686,0 -0.28235,-0.1098 -0.29804,-0.26667c-0.04706,-0.15686 0.1098,-0.26667 0.25098,-0.29804c0.59608,-0.03137 1.12942,0.40785 1.19216,1.00393c0.04706,0.62745 -0.40785,1.17648 -1.0353,1.23922z",
    className: "st18",
    id: "svg_132"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m745.56616,497.04737l-12.69028,0c-0.73726,0 -1.34903,0.59608 -1.34903,1.33334c0,0 0,0 0,0.01569l0,1.05099c0,2.00786 1.63138,3.63924 3.63924,3.63924s3.63924,-1.63138 3.63924,-3.63924l0,-1.05099c0,-0.29804 -0.1098,-0.59608 -0.29804,-0.81569l1.42746,0c-0.18824,0.2353 -0.26667,0.53334 -0.26667,0.81569l0,1.05099c0,2.00786 1.63138,3.63924 3.63924,3.63924s3.63924,-1.63138 3.63924,-3.63924l0,-1.05099c-0.01569,-0.73726 -0.62745,-1.34903 -1.3804,-1.34903c0.01569,0 0.01569,0 0,0zm-7.29416,1.34903l0,1.05099c0.01569,1.70981 -1.36471,3.09022 -3.07453,3.1059s-3.09022,-1.36471 -3.1059,-3.07453l0,-1.05099c0,-0.4549 0.37647,-0.81569 0.81569,-0.81569l4.59611,0c0.42353,0 0.75295,0.3451 0.75295,0.75295c0.03137,0.01569 0.03137,0.03137 0.01569,0.03137l0,0zm8.12554,1.00393c0.01569,1.70981 -1.36471,3.09022 -3.07453,3.1059s-3.09022,-1.36471 -3.1059,-3.07453l0,0l0,-1.05099c0,-0.4549 0.37647,-0.81569 0.81569,-0.81569l4.61179,0c0.4549,0 0.81569,0.37647 0.81569,0.81569l-0.06275,1.01961z",
    className: "st4",
    id: "svg_130"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FA9B9B",
    d: "m703.90314,546.88299l0.03137,27.37272l11.01184,-1.08236l5.80396,-26.27468l-16.84717,-0.01569z",
    className: "st14",
    id: "svg_129"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FA9B9B",
    d: "m712.21692,559.52621l3.67061,-5.01964l2.69806,-10.9334c0.12549,-0.51765 0.32941,-1.01961 0.64314,-1.45883c0.43922,-0.5804 1.01961,-1.0353 1.67844,-1.30197l9.01967,-4.34513c0.5804,-0.26667 1.2706,-0.03137 1.56864,0.51765c0.31373,0.56471 0.1098,1.25491 -0.4549,1.56864l-7.52946,4.59611l6.77651,-2.16472c0.62745,-0.18824 1.28628,0.15686 1.47452,0.78432c0.03137,0.12549 0.06275,0.25098 0.04706,0.37647c-0.03137,0.43922 -0.28235,0.81569 -0.67451,1.00393l-7.93731,3.37257l6.02357,-2.54119c0.54902,-0.2353 1.17648,0.03137 1.41177,0.5804c0.06275,0.14118 0.07843,0.28235 0.07843,0.42353c0.01569,0.37647 -0.18824,0.72157 -0.51765,0.89412l-6.50985,3.96865l4.29807,-2.58825c0.4549,-0.26667 1.0353,-0.12549 1.31766,0.32941c0.04706,0.07843 0.09412,0.17255 0.1098,0.26667c0.06275,0.31373 -0.01569,0.64314 -0.21961,0.89412l-3.70198,3.70198l-7.90593,24.10996c-2.0706,4.90984 -5.36474,-17.0354 -5.36474,-17.0354z",
    className: "st14",
    id: "svg_128"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FA9B9B",
    d: "m711.3228,561.62818l-5.94514,7.8275c-2.36864,3.12159 -1.74119,7.56083 1.3804,9.92948c3.12159,2.36864 7.56083,1.74119 9.92948,-1.3804c0.3451,-0.4549 0.62745,-0.95687 0.86275,-1.47452l3.56081,-10.74517l-9.7883,-4.15689z",
    className: "st14",
    id: "svg_127"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m715.8091,554.31833l2.77649,-10.90203c0.26667,-1.05099 0.97256,-1.91374 1.94511,-2.40002l1.05099,-0.51765l0.03137,-0.89412l-2.35296,1.12942c-1.01961,0.48628 -1.77256,1.41177 -2.02354,2.50982l-2.47845,10.71379l-10.52556,13.4746l-0.26667,4.10983l11.84321,-17.22364z",
    className: "st7",
    id: "svg_126"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FA9B9B",
    d: "m779.00951,541.1104l9.31771,15.41971l-15.38833,2.69806l-6.93338,-14.33735l13.004,-3.78042z",
    className: "st14",
    id: "svg_125"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m766.27217,545.34572l0.75295,0.26667l0.70589,-3.56081l-3.85885,0.97256l2.40002,2.32158z",
    className: "st4",
    id: "svg_124"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m728.76605,541.48687l-0.64314,-1.12942l1.53726,-0.94118l-0.37647,1.86668l-0.51765,0.20392z",
    className: "st4",
    id: "svg_123"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m726.82094,538.0045l-4.29807,-7.59221c-0.25098,-0.47059 -0.1098,-1.05099 0.32941,-1.34903c0.43922,-0.28235 1.0353,-0.15686 1.33334,0.28235c0.01569,0.03137 0.03137,0.06275 0.04706,0.09412l4.45493,7.7177l-1.86668,0.84706z",
    className: "st4",
    id: "svg_122"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.15,
    className: "st17",
    transform: "translate(251.955 222.888)",
    id: "svg_120"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m328.33996,197.01408c-0.12549,0 -0.21961,-0.07843 -0.26667,-0.18824c-0.06275,-0.14118 0,-0.29804 0.12549,-0.36079c0.01569,0 0.01569,-0.01569 0.03137,-0.01569l5.16082,-2.19609c0.14118,-0.07843 0.31373,-0.01569 0.39216,0.12549c0.07843,0.14118 0.01569,0.31373 -0.12549,0.37647c-0.01569,0 -0.01569,0.01569 -0.03137,0.01569l-5.1765,2.21178c-0.03137,0.03137 -0.07843,0.04706 -0.1098,0.03137z",
    className: "st7",
    id: "svg_121"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m723.5268,543.13394l4.45493,-1.42746l0.29804,0.64314l-4.75297,0.78432z",
    className: "st7",
    id: "svg_119"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.15,
    className: "st17",
    transform: "translate(252.356 224.887)",
    id: "svg_117"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m328.30858,197.1082c-0.09412,0 -0.18824,-0.06275 -0.21961,-0.15686c-0.07843,-0.12549 -0.03137,-0.28235 0.07843,-0.36079c0.01569,0 0.01569,-0.01569 0.03137,-0.01569l3.85885,-2.32158c0.12549,-0.07843 0.28235,-0.03137 0.36079,0.09412c0,0 0,0.01569 0.01569,0.01569c0.07843,0.12549 0.04706,0.28235 -0.07843,0.36079c-0.01569,0 -0.01569,0.01569 -0.03137,0.01569l-3.87453,2.32158c-0.06275,0 -0.1098,0.04706 -0.14118,0.04706z",
    className: "st7",
    id: "svg_118"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m757.28388,531.25936l1.7255,4.59611c0.07843,0.21961 -0.03137,0.4549 -0.25098,0.53334c-0.04706,0.01569 -0.07843,0.03137 -0.12549,0.03137l-1.91374,0c-0.21961,0 -0.40785,-0.18824 -0.40785,-0.40785l0.18824,-4.59611c0.01569,-0.21961 0.20392,-0.40785 0.42353,-0.39216c0.15686,0 0.29804,0.09412 0.36079,0.2353z",
    className: "st7",
    id: "svg_116"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m721.58169,540.51432l0.15686,-7.26279c0,-0.2353 0.20392,-0.43922 0.4549,-0.42353c0.18824,0 0.36079,0.12549 0.40785,0.31373l1.80393,6.02357l-2.82355,1.34903z",
    className: "st7",
    id: "svg_115"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.6,
    d: "m742.00535,514.45925l0.29804,2.96472c0.07843,0.5804 -0.15686,1.16079 -0.59608,1.53726l-6.47847,5.50592c-0.25098,0.20392 -0.59608,0.21961 -0.86275,0.03137l-8.72162,-5.94514c-0.26667,-0.32941 -0.42353,-0.73726 -0.40785,-1.16079l0.1098,-1.34903l-2.16472,0.94118l0,1.56864c0.09412,0.31373 0.29804,0.59608 0.56471,0.78432l10.29026,7.23142c0.53334,0.37647 1.2706,0.32941 1.75687,-0.1098l8.04711,-7.15299c0.3451,-0.28235 0.51765,-0.72157 0.48628,-1.16079l-0.37647,-3.51375l-1.94511,-0.17255z",
    className: "st20",
    id: "svg_114"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.6,
    d: "m703.90314,546.8673l12.47067,0l0.48628,-2.05492l-12.90989,0l0,2.05492l-0.04706,0z",
    className: "st20",
    id: "svg_113"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.6,
    d: "m779.00951,541.1104l-1.19216,-2.05492l-10.07065,2.96472l-0.48628,2.50982l11.74909,-3.41963z",
    className: "st20",
    id: "svg_112"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m757.95839,534.06722l-5.64709,0c-0.47059,-1.17648 -1.6157,-1.9608 -2.88629,-1.94511c-1.11373,0.01569 -2.03923,0.84706 -2.16472,1.94511l-4.8314,0c-0.37647,0 -0.70589,0.26667 -0.78432,0.64314l-1.6157,6.58828c-0.1098,0.43922 0.15686,0.87844 0.59608,0.98824c0.06275,0.01569 0.12549,0.01569 0.18824,0.01569l15.52951,0c0.37647,0 0.70589,-0.26667 0.78432,-0.64314l1.6157,-6.58828c0.1098,-0.43922 -0.15686,-0.87844 -0.59608,-0.98824c-0.06275,0 -0.12549,-0.01569 -0.18824,-0.01569z",
    className: "st4",
    id: "svg_111"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#3F4249",
    d: "m758.4133,536.43586l0.32941,-1.34903c0.1098,-0.43922 -0.15686,-0.87844 -0.59608,-0.98824c-0.06275,-0.01569 -0.12549,-0.01569 -0.18824,-0.01569l-5.64709,0c-0.47059,-1.17648 -1.6157,-1.9608 -2.88629,-1.94511c-1.11373,0.01569 -2.03923,0.84706 -2.16472,1.94511l-4.8314,0c-0.37647,0 -0.70589,0.26667 -0.78432,0.64314l-0.4549,1.75687l17.22364,0l0,-0.04706z",
    className: "st15",
    id: "svg_110"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m752.12306,533.7378l-4.8314,0c-0.03137,0.1098 -0.03137,0.18824 -0.07843,0.29804l5.01964,0c0,-0.1098 -0.04706,-0.21961 -0.1098,-0.29804z",
    className: "st4",
    id: "svg_109"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#3F4249",
    d: "m721.12678,583.04008l33.99237,0c1.63138,0 3.02747,-1.14511 3.37257,-2.72943l8.56476,-42.11792c0.15686,-0.80001 -0.37647,-1.58432 -1.17648,-1.74119c-0.09412,-0.01569 -0.18824,-0.03137 -0.28235,-0.03137l-33.99237,0c-1.63138,0 -3.02747,1.14511 -3.37257,2.72943l-8.56476,42.11792c-0.14118,0.81569 0.40785,1.60001 1.22354,1.74119c0.07843,0.01569 0.15686,0.03137 0.2353,0.03137z",
    className: "st15",
    id: "svg_108"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m722.58562,583.04008l33.99237,0c1.63138,0 3.02747,-1.14511 3.37257,-2.72943l8.56476,-42.11792c0.15686,-0.80001 -0.37647,-1.58432 -1.17648,-1.74119c-0.09412,-0.01569 -0.18824,-0.03137 -0.28235,-0.03137l-33.99237,0c-1.63138,0 -3.02747,1.14511 -3.37257,2.72943l-8.56476,42.11792c-0.15686,0.80001 0.37647,1.58432 1.17648,1.74119c0.09412,0.01569 0.18824,0.03137 0.28235,0.03137z",
    className: "st4",
    id: "svg_107"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FA9B9B",
    d: "m774.47615,548.26339l-2.43139,1.3804l-4.7216,-3.70198c-0.50196,-0.39216 -1.09805,-0.65883 -1.7255,-0.75295c-0.64314,-0.06275 -1.30197,0.01569 -1.91374,0.21961l-9.58438,2.96472c-0.61177,0.20392 -0.94118,0.84706 -0.78432,1.45883c0.14118,0.62745 0.75295,1.01961 1.3804,0.87844c0.01569,0 0.03137,0 0.04706,-0.01569l8.56476,-1.78825l-6.43141,3.02747c-0.5804,0.28235 -0.83138,0.98824 -0.54902,1.56864c0.04706,0.1098 0.12549,0.21961 0.20392,0.29804c0.31373,0.31373 0.76863,0.42353 1.19216,0.29804l8.07848,-2.91767l-6.18043,2.24315c-0.56471,0.20392 -0.84706,0.81569 -0.64314,1.3804c0.04706,0.14118 0.12549,0.26667 0.2353,0.37647c0.26667,0.26667 0.64314,0.39216 1.00393,0.32941l7.93731,-1.64707l-5.39611,1.12942c-0.50196,0.07843 -0.84706,0.56471 -0.75295,1.06667c0.01569,0.1098 0.06275,0.21961 0.12549,0.31373c0.15686,0.28235 0.4549,0.47059 0.78432,0.48628l5.23925,0.18824l5.91376,6.99612c2.7608,3.3412 7.57652,4.1412 11.26282,1.86668c0.12549,-0.07843 0.25098,-0.17255 0.37647,-0.26667l0.21961,-0.15686c2.40002,-4.75297 -11.45105,-17.22364 -11.45105,-17.22364z",
    className: "st14",
    id: "svg_106"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FA9B9B",
    d: "m774.47615,548.26339l8.72162,4.42356c3.85885,0.67451 6.43141,4.36081 5.7569,8.21966c-0.67451,3.85885 -4.36081,6.43141 -8.21966,5.7569c-0.54902,-0.09412 -1.09805,-0.26667 -1.6157,-0.48628l-5.42749,-5.34905l0.78432,-12.56479z",
    className: "st14",
    id: "svg_105"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m772.04476,549.64379l-4.8314,-3.78042l4.7216,2.35296l13.20793,2.9961l2.21178,3.81179l-15.3099,-5.38043z",
    className: "st7",
    id: "svg_104"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.15,
    className: "st17",
    transform: "translate(276.722 229.254)",
    id: "svg_102"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m334.44196,194.44152c-0.04706,-0.14118 -0.18824,-0.2353 -0.32941,-0.21961l-4.26669,0.86275l-1.09805,0.21961c-0.3451,0.06275 -0.62745,0.32941 -0.70589,0.67451l6.18043,-1.23922c0.14118,0 0.21961,-0.14118 0.21961,-0.29804z",
    className: "st7",
    id: "svg_103"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m766.02119,551.63596c0.14118,-0.04706 0.20392,-0.20392 0.15686,-0.32941c-0.04706,-0.14118 -0.20392,-0.20392 -0.32941,-0.15686l-2.80786,1.05099l2.83923,-1.05099l-3.29414,1.19216l-3.02747,1.12942c-0.28235,0.15686 -0.47059,0.43922 -0.51765,0.75295l0.07843,0l6.902,-2.58825z",
    className: "st7",
    id: "svg_101"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#868A91",
    d: "m1038.24254,625.40898l0,0z",
    className: "st21",
    id: "svg_100"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart);
export default __webpack_public_path__ + "static/media/Start.3e52e1184d5e3c826a010622c66512ff.svg";
export { ForwardRef as ReactComponent };